export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string. */
  BigInt: unknown
  /** An ISO 8601-encoded date */
  FormattedDate: string
  /** An ISO 8601-encoded date */
  ISO8601Date: string
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string
  /** Represents untyped JSON */
  JSON: unknown
}

/** Autogenerated input type of AcceptAgreement */
export type AcceptAgreementInput = {
  /** Accept e-sign consent in addition to the agreement - acceptance  */
  acceptEsign?: InputMaybe<Scalars['Boolean']>
  acceptanceId?: InputMaybe<Scalars['Int']>
  agreementId?: InputMaybe<Scalars['Int']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Metadata to be added to the acceptance */
  metadata?: InputMaybe<Scalars['JSON']>
  /** The ID of the acceptance owner - defaults to the current user or acceptance owner */
  ownerId?: InputMaybe<Scalars['Int']>
  /** a public URL or a base64-encoded data URL of the acceptance signature PNG, e.g. data:image/png;base64,... */
  signatureSrc?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of AcceptAgreement. */
export type AcceptAgreementPayload = {
  __typename?: 'AcceptAgreementPayload'
  acceptance?: Maybe<Acceptance>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
}

/** An acceptance of an agreement */
export type Acceptance = {
  __typename?: 'Acceptance'
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']>
  accepter: AcceptanceAccepter
  agreement: Agreement
  createdAt: Scalars['ISO8601DateTime']
  formUrl?: Maybe<Scalars['String']>
  id: Scalars['Int']
  signedDocument?: Maybe<File>
  withdrawnAt?: Maybe<Scalars['ISO8601DateTime']>
}

/** The accepter of an acceptance */
export type AcceptanceAccepter = {
  __typename?: 'AcceptanceAccepter'
  email: Scalars['String']
  id: Scalars['Int']
  name: Scalars['String']
}

export enum AccessRequirementEnum {
  /** The user does not have access to the feature */
  Forbidden = 'forbidden',
  /** The user has full access to the feature */
  Ok = 'ok',
  /** The user must enter their password to access the feature */
  Password = 'password',
}

/** Physical address information for display, including verification status */
export type AddressDisplay = {
  __typename?: 'AddressDisplay'
  cityName?: Maybe<Scalars['String']>
  /** Was it added by user for mailing */
  isMailing: Scalars['Boolean']
  /** Verification status corresponds to passing verification check */
  isVerified: Scalars['Boolean']
  line1?: Maybe<Scalars['String']>
  line2?: Maybe<Scalars['String']>
  stateCode?: Maybe<Scalars['String']>
  /** Verification status */
  verificationStatus?: Maybe<AddressVerificationStatus>
  /** Date when verification was checked */
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']>
  zipcode?: Maybe<Scalars['String']>
}

/** Attributes to create or update an address */
export type AddressInput = {
  cityName: Scalars['String']
  line1: Scalars['String']
  line2?: InputMaybe<Scalars['String']>
  /** Instruction to verify the address */
  mustVerify?: InputMaybe<Scalars['Boolean']>
  stateCode?: InputMaybe<Scalars['String']>
  zipcode: Scalars['String']
}

/** The verification status of an address */
export enum AddressVerificationStatus {
  Deliverable = 'deliverable',
  IncorrectOrMissingUnit = 'incorrect_or_missing_unit',
  Undeliverable = 'undeliverable',
  Unknown = 'unknown',
}

/** An agreement */
export type Agreement = {
  __typename?: 'Agreement'
  /** @deprecated This field will be removed in a future version. Use type instead */
  agreementType: AgreementTypeEnum
  agreementVersion: Scalars['FormattedDate']
  effectiveDate?: Maybe<Scalars['FormattedDate']>
  id: Scalars['Int']
  isMostRecent: Scalars['Boolean']
  name: Scalars['String']
  type: Scalars['String']
}

/** An agreement */
export type AgreementAgreementVersionArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** An agreement */
export type AgreementEffectiveDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** The type of agreement */
export enum AgreementTypeEnum {
  PthEmployeeTos = 'pth_employee_tos',
  PthOrderForm = 'pth_order_form',
  PthOrganizationTos = 'pth_organization_tos',
  StripeIssuingCelticApplePaymentCustomerTermsAndConditions = 'stripe_issuing_celtic_apple_payment_customer_terms_and_conditions',
  StripeIssuingCelticAuthorizedUserTerms = 'stripe_issuing_celtic_authorized_user_terms',
  StripeIssuingEsignDisclosure = 'stripe_issuing_esign_disclosure',
  UserEsignConsent = 'user_esign_consent',
}

export type AliceCard = {
  __typename?: 'AliceCard'
  activatedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** The ID of the card in the external system (e.g. Stripe, Synapse) */
  bankingSystemId?: Maybe<Scalars['String']>
  cardType: AliceCardType
  createdAt: Scalars['ISO8601DateTime']
  /** The ephemeral key object returned from the Stripe API */
  ephemeralKey?: Maybe<Scalars['JSON']>
  /**
   * The ephemeral key secret used to display card details in a web application
   * @deprecated use ephemeralKey(nonce:) query and parse result
   */
  ephemeralKeySecret?: Maybe<Scalars['String']>
  /** When it is estimated the Alice Card will be delivered. Only applicable for physical cards. */
  etaToCustomer?: Maybe<Scalars['FormattedDate']>
  expiryDate: Scalars['FormattedDate']
  id: Scalars['Int']
  isConnectedToDigitalWallet: Scalars['Boolean']
  issuingPlatform: AliceCardIssuingPlatform
  last4: Scalars['String']
  reportedMissingAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Card shipping status. Only applicable for physical cards. */
  shippingStatus?: Maybe<AliceCardShippingStatus>
  status: AliceCardStatus
  /** The wallets that the card is enrolled in */
  wallets?: Maybe<StripeWallets>
}

export type AliceCardEphemeralKeyArgs = {
  nonce?: InputMaybe<Scalars['String']>
}

export type AliceCardEphemeralKeySecretArgs = {
  nonce: Scalars['String']
}

export type AliceCardEtaToCustomerArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type AliceCardExpiryDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** Information about the employee's Alice Card(s) */
export type AliceCardAccount = {
  __typename?: 'AliceCardAccount'
  /** @deprecated use spendingConnectionInfo.aliceCard(id:) query */
  aliceCard?: Maybe<AliceCard>
  /** @deprecated only for Synapse cards - no longer used */
  aliceCardEnrollment?: Maybe<AliceCardEnrollment>
  aliceCards: Array<AliceCard>
  cardProvisioningStatus: AliceCardProvisioningStatusInfo
  /** @deprecated use cardProvisioningStatus */
  cardTypesRequested?: Maybe<AliceCardType>
  id: Scalars['Int']
  /** The name of the platform for the account */
  platform: AliceCardPlatform
  status: AliceCardAccountStatus
}

/** Information about the employee's Alice Card(s) */
export type AliceCardAccountAliceCardArgs = {
  id: Scalars['Int']
}

export enum AliceCardAccountStatus {
  Active = 'active',
  BalanceGated = 'balance_gated',
  Blocked = 'blocked',
  Inactive = 'inactive',
  Terminated = 'terminated',
}

/** An Alice Card authorization (i.e. purchase attempt) */
export type AliceCardAuthorization = {
  __typename?: 'AliceCardAuthorization'
  aliceCard?: Maybe<AliceCard>
  approved: Scalars['Boolean']
  authorizationTime?: Maybe<Scalars['ISO8601DateTime']>
  authorizedAmount: Scalars['Int']
  bankingTransaction?: Maybe<BankingTransaction>
  declineReason?: Maybe<Scalars['String']>
  id: Scalars['Int']
  isForcePost: Scalars['Boolean']
  name?: Maybe<Scalars['String']>
  pretaxCategory?: Maybe<PretaxCategory>
  requestedAmount: Scalars['Int']
  status?: Maybe<AliceCardAuthorizationStatusValue>
  walletProvider?: Maybe<Scalars['String']>
}

/** The connection type for AliceCardAuthorization. */
export type AliceCardAuthorizationConnection = {
  __typename?: 'AliceCardAuthorizationConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AliceCardAuthorizationEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AliceCardAuthorization>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type AliceCardAuthorizationEdge = {
  __typename?: 'AliceCardAuthorizationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<AliceCardAuthorization>
}

export enum AliceCardAuthorizationStatusValue {
  /** Closed */
  Closed = 'closed',
  /** Pending */
  Pending = 'pending',
  /** Reversed */
  Reversed = 'reversed',
}

export type AliceCardEnrollment = {
  __typename?: 'AliceCardEnrollment'
  /** Is the user enrolled right now */
  enrolled: Scalars['Boolean']
  /** The date of initial enrollment */
  enrolledAt?: Maybe<Scalars['ISO8601DateTime']>
  /** The date when the the user opted out (or was opted out by admin) */
  optedOutAt?: Maybe<Scalars['ISO8601DateTime']>
  /** The date when the Terms of Service were accepted */
  tosAcceptedAt?: Maybe<Scalars['ISO8601DateTime']>
}

/** Funding information for the parent object */
export type AliceCardFunding = {
  __typename?: 'AliceCardFunding'
  availablePaymentMethods?: Maybe<Array<PaymentMethod>>
  paymentMethodConnections?: Maybe<Array<PaymentMethodConnection>>
  status: AliceCardFundingStatus
  /** @deprecated no longer used */
  verificationUrl?: Maybe<Scalars['String']>
}

/** Status of the card funding for the parent object */
export enum AliceCardFundingStatus {
  /** Blocked */
  Blocked = 'blocked',
  /** Connected */
  Connected = 'connected',
  /** Not connected */
  NotConnected = 'not_connected',
}

/** The issuing platform of an alice card. Eg 'stripe' or 'synapse' */
export enum AliceCardIssuingPlatform {
  Stripe = 'stripe',
  Synapse = 'synapse',
}

/** The status of the organization's Stripe Issuing integration */
export enum AliceCardIssuingStatus {
  Active = 'active',
  Deactivated = 'deactivated',
  Enabled = 'enabled',
  NotSubmitted = 'not_submitted',
  Submitted = 'submitted',
}

export enum AliceCardKycStatus {
  /** Complete */
  Complete = 'complete',
  /** Not started */
  NotStarted = 'not_started',
  /** Pending */
  Pending = 'pending',
  /** Started */
  Started = 'started',
}

export enum AliceCardPlatform {
  Stripe = 'stripe',
  Synapse = 'synapse',
}

/** Organization-specific configuration for the Alice Card program */
export type AliceCardProgram = {
  __typename?: 'AliceCardProgram'
  /** Employees who have expressed interest in the Alice Card program - use pageInfo to get count */
  balanceGatedEmployees: EmployeeConnection
  /** Status of the organization's Stripe Issuing integration */
  cardIssuingStatus: AliceCardIssuingStatus
  companyAccount?: Maybe<StripeCompanyAccount>
  employeeFundingCount: Scalars['Int']
  hasFundingConnected: Scalars['Boolean']
  hasUnifiedBanking?: Maybe<Scalars['Boolean']>
  kycStatus: AliceCardKycStatus
  perEmployeeFundingAmount: Scalars['Int']
  reserveAmount: Scalars['Int']
}

/** Organization-specific configuration for the Alice Card program */
export type AliceCardProgramBalanceGatedEmployeesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export enum AliceCardProvisioningStatus {
  Provisioned = 'provisioned',
  Requested = 'requested',
}

export type AliceCardProvisioningStatusInfo = {
  __typename?: 'AliceCardProvisioningStatusInfo'
  instant?: Maybe<AliceCardProvisioningStatus>
  physical?: Maybe<AliceCardProvisioningStatus>
}

export enum AliceCardShippingStatus {
  Canceled = 'canceled',
  Delivered = 'delivered',
  Pending = 'pending',
  Returned = 'returned',
  Shipped = 'shipped',
}

export enum AliceCardStatus {
  Active = 'active',
  Canceled = 'canceled',
  Inactive = 'inactive',
  Terminated = 'terminated',
}

export enum AliceCardType {
  Instant = 'instant',
  /** An instant card and a physical card */
  InstantAndPhysical = 'instant_and_physical',
  Physical = 'physical',
  /** A virtual card */
  Virtual = 'virtual',
}

/** Employee accounting ledger with balances for all benefits */
export type AliceLedger = {
  __typename?: 'AliceLedger'
  commuter?: Maybe<CommuterLedger>
  createdAt: Scalars['ISO8601DateTime']
  /** Total savings for all benefits over the lifetime of the employee's account */
  estimatedLifetimeSavings: Scalars['Int']
  id: Scalars['Int']
  /** Paginated pay period records for the requested employee */
  payPeriodRecords: PayPeriodRecordConnection
  updatedAt: Scalars['ISO8601DateTime']
}

/** Employee accounting ledger with balances for all benefits */
export type AliceLedgerPayPeriodRecordsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

/** Autogenerated input type of AssignCompanyRepresentative */
export type AssignCompanyRepresentativeInput = {
  /** User address */
  address?: InputMaybe<AddressInput>
  /** User birthdate */
  birthdate?: InputMaybe<Scalars['ISO8601Date']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Organization ID */
  orgId: Scalars['Int']
  /** Social Security Number */
  ssn?: InputMaybe<Scalars['String']>
  /** User telephone number */
  tel?: InputMaybe<Scalars['String']>
  /** User ID to assign as company representative */
  userId: Scalars['Int']
}

/** Autogenerated return type of AssignCompanyRepresentative. */
export type AssignCompanyRepresentativePayload = {
  __typename?: 'AssignCompanyRepresentativePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of AssignUserToStep */
export type AssignUserToStepInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  orgId: Scalars['Int']
  /** Type of step to assign user to */
  stepType: OnboardingStepType
  /** ID of existing user to assign */
  userId: Scalars['Int']
}

/** Autogenerated return type of AssignUserToStep. */
export type AssignUserToStepPayload = {
  __typename?: 'AssignUserToStepPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  /** The updated onboarding step */
  onboardingStep?: Maybe<OnboardingStep>
  organization?: Maybe<Organization>
  /** The assigned user */
  user?: Maybe<User>
}

/** A merchant name that is automatically confirmed for an employee */
export type AutoConfirmationMatch = {
  __typename?: 'AutoConfirmationMatch'
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  merchantName: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
}

export type Balance = {
  __typename?: 'Balance'
  remaining: Scalars['Int']
  used: Scalars['Int']
}

export type BalanceInfo = {
  __typename?: 'BalanceInfo'
  balanceResetDate: Scalars['FormattedDate']
  /** @deprecated Use balance_reset_date instead */
  estimatedBalanceResetDate: Scalars['FormattedDate']
  massTransit: Balance
  monthStart: Scalars['FormattedDate']
  parking: Balance
}

export type BalanceInfoBalanceResetDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type BalanceInfoEstimatedBalanceResetDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type BalanceInfoMonthStartArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** An object that contains a possible reason why a balance may be constrained */
export type BalanceLimitation = {
  __typename?: 'BalanceLimitation'
  contributionDelinquency?: Maybe<Scalars['ISO8601DateTime']>
  employeeTermination?: Maybe<Scalars['ISO8601DateTime']>
  employerOffboarding?: Maybe<Scalars['ISO8601DateTime']>
  planYearEndDate?: Maybe<Scalars['ISO8601DateTime']>
  /** Amount of spend allowed for the benefit with respect to the spending period */
  spendingCap?: Maybe<Scalars['Int']>
}

export enum BankCardType {
  Credit = 'credit',
  Debit = 'debit',
  Instant = 'instant',
  Omny = 'omny',
}

export enum BankableTypeEnum {
  Org = 'org',
  Paygroup = 'paygroup',
}

/** A client account that is held at a connected institution, including Alice Card */
export type BankingAccount = {
  __typename?: 'BankingAccount'
  accountType?: Maybe<BankingAccountType>
  /** The ID of the banking account in the billing system */
  billingSystemId?: Maybe<Scalars['String']>
  /** The type of card, if known and applicable (will not be available for bank accounts) */
  cardType?: Maybe<BankCardType>
  error?: Maybe<Error>
  id: Scalars['Int']
  last4?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  platform: BankingAccountPlatform
}

/** The platform that provides the account */
export enum BankingAccountPlatform {
  AliceCardStripe = 'alice_card_stripe',
  AliceCardSynapse = 'alice_card_synapse',
  Finicity = 'finicity',
  Offline = 'offline',
  Omny = 'omny',
  Plaid = 'plaid',
  Quovo = 'quovo',
  Stripe = 'stripe',
}

/** The type of account, if known - may be empty */
export enum BankingAccountType {
  Alice = 'alice',
  Banking = 'banking',
  Brokerage = 'brokerage',
  Credit = 'credit',
  Depository = 'depository',
  Insurance = 'insurance',
  Investment = 'investment',
  Loan = 'loan',
  Other = 'other',
  Unknown = 'unknown',
}

/** A user-specific connection to an institution that provides account and transaction information */
export type BankingConnection = {
  __typename?: 'BankingConnection'
  /** Phyical card shipment for this connection, if any (only OMNY) */
  activeCardShipment?: Maybe<CardShipment>
  /** user's accounts that are held at the connected institution */
  bankingAccounts: Array<BankingAccount>
  /** The ID of the connection */
  id: Scalars['Int']
  institution?: Maybe<BankingInstitution>
  platform?: Maybe<BankingAccountPlatform>
  status: BankingConnectionStatus
}

export enum BankingConnectionPlatform {
  Finicity = 'finicity',
  Offline = 'offline',
  Omny = 'omny',
  Plaid = 'plaid',
  Quovo = 'quovo',
}

export enum BankingConnectionStatus {
  AliceDisconnected = 'alice_disconnected',
  Connected = 'connected',
  ConnectionError = 'connection_error',
  CustomerDisconnected = 'customer_disconnected',
  Disconnecting = 'disconnecting',
  Pending = 'pending',
  SystemDisconnected = 'system_disconnected',
}

/** A bank, or at least something that aggregates accounts */
export type BankingInstitution = {
  __typename?: 'BankingInstitution'
  /** Internal BankingInstitution ID */
  id: Scalars['Int']
  /** The name of the connected institution */
  name?: Maybe<Scalars['String']>
  /** The platform that currently provides the connection */
  platform: BankingInstitutionPlaform
  /** The institution identifier used by the preferred platform */
  platformId?: Maybe<Scalars['String']>
  /** The platform that we prefer to use for the connection - reconnect should use this if possible */
  preferredPlatform?: Maybe<BankingInstitutionPlaform>
  /** The ID of the unified institution */
  unifiedInstitutionId?: Maybe<Scalars['Int']>
}

export enum BankingInstitutionPlaform {
  Finicity = 'finicity',
  Plaid = 'plaid',
  Quovo = 'quovo',
}

/** A record of a banking transaction */
export type BankingTransaction = {
  __typename?: 'BankingTransaction'
  account: FundingAccount
  amount: Scalars['Int']
  date: Scalars['FormattedDate']
  estimatedSavings: Scalars['Int']
  id: Scalars['ID']
  /** Just the merchant name, might not always be available */
  merchantName?: Maybe<Scalars['String']>
  /** The merchant name and some other text (including junky characters sometimes) */
  name: Scalars['String']
  platform: BankingTransactionPlatform
  refunded: Scalars['Boolean']
  refundedAmount: Scalars['Int']
  reimbursementClaim?: Maybe<ReimbursementClaim>
  reimbursementStatus?: Maybe<ReimbursementStatus>
  spendEligibility: SpendEligibility
  subsidizedAmount: Scalars['Int']
}

/** A record of a banking transaction */
export type BankingTransactionDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** The connection type for BankingTransaction. */
export type BankingTransactionConnection = {
  __typename?: 'BankingTransactionConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BankingTransactionEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BankingTransaction>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type BankingTransactionEdge = {
  __typename?: 'BankingTransactionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<BankingTransaction>
}

export enum BankingTransactionPlatform {
  AliceCardStripe = 'alice_card_stripe',
  AliceCardSynapse = 'alice_card_synapse',
  Finicity = 'finicity',
  Offline = 'offline',
  Omny = 'omny',
  Plaid = 'plaid',
  Quovo = 'quovo',
}

export enum BenefitType {
  DependentCareFsa = 'dependent_care_fsa',
  HealthcareFsa = 'healthcare_fsa',
  HealthcareHsa = 'healthcare_hsa',
  LimitedPurposeFsa = 'limited_purpose_fsa',
  MassTransit = 'mass_transit',
  Parking = 'parking',
}

export enum BillableType {
  Org = 'org',
  Paygroup = 'paygroup',
}

/** Billing information for a billable entity, e.g. organization or employer */
export type Billing = {
  __typename?: 'Billing'
  billingSource?: Maybe<BillingSource>
  /** The ID of the billable entity in the billing system */
  billingSystemId?: Maybe<Scalars['String']>
  billingWorkspace: BillingWorkspace
  hasBillingConnected: Scalars['Boolean']
  hasUnifiedBilling: Scalars['Boolean']
  invoice?: Maybe<Invoice>
  invoicesConnection: InvoiceConnection
}

/** Billing information for a billable entity, e.g. organization or employer */
export type BillingInvoiceArgs = {
  id: Scalars['Int']
}

/** Billing information for a billable entity, e.g. organization or employer */
export type BillingInvoicesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  employerId?: InputMaybe<Scalars['Int']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

/** The source of billing funds for a billable entity */
export type BillingSource = BankingAccount | PaymentCard

export enum BillingWorkspace {
  Pretaxhero = 'pretaxhero',
  Thisisalice = 'thisisalice',
}

/** Business profile information stored in Stripe's account.business_profile */
export type BusinessProfile = {
  __typename?: 'BusinessProfile'
  /** Annual revenue in cents */
  annualRevenue?: Maybe<Scalars['Int']>
  /** Estimated number of workers */
  estimatedWorkerCount?: Maybe<Scalars['Int']>
  /** Fiscal year end date */
  fiscalYearEnd?: Maybe<Scalars['FormattedDate']>
  /** Merchant Category Code */
  mcc?: Maybe<Mcc>
  /** Customer-facing business name */
  name?: Maybe<Scalars['String']>
  /** Business website URL */
  url?: Maybe<Scalars['String']>
}

/** Business profile information stored in Stripe's account.business_profile */
export type BusinessProfileFiscalYearEndArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** Autogenerated input type of CancelAliceCard */
export type CancelAliceCardInput = {
  aliceCardId: Scalars['Int']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  replace?: InputMaybe<Scalars['Boolean']>
  reportMissing?: InputMaybe<Scalars['Boolean']>
}

/** Autogenerated return type of CancelAliceCard. */
export type CancelAliceCardPayload = {
  __typename?: 'CancelAliceCardPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** The type of card request */
export enum CardRequestTypeEnum {
  Instant = 'instant',
  InstantAndPhysical = 'instant_and_physical',
  Physical = 'physical',
}

/** A shipment of a physical card to a user */
export type CardShipment = {
  __typename?: 'CardShipment'
  id: Scalars['Int']
  platform: BankingAccountPlatform
  reportedMissingAt?: Maybe<Scalars['ISO8601DateTime']>
  shippedAt?: Maybe<Scalars['ISO8601DateTime']>
}

export enum CardShipmentStatus {
  Missing = 'missing',
  Received = 'received',
}

export type CashPaymentAccount = {
  __typename?: 'CashPaymentAccount'
  id: Scalars['ID']
}

/** A representation of a time duration with a fixed starting datetime and ending datetime */
export type ClosedTimePeriod = {
  __typename?: 'ClosedTimePeriod'
  endDate: Scalars['ISO8601DateTime']
  startDate: Scalars['ISO8601DateTime']
}

/** Employee accounting ledger with balances for dependent care enrollment(s) */
export type CommuterLedger = EnrollmentLedger & {
  __typename?: 'CommuterLedger'
  contributions: ContributionBreakdown
  createdAt: Scalars['ISO8601DateTime']
  current?: Maybe<LegerBalance>
  deductions: DeductionBreakdown
  enrollments: Array<Enrollment>
  id: Scalars['Int']
  massTransit?: Maybe<MassTransitLedger>
  parking?: Maybe<ParkingLedger>
  reimbursement: ReimbursementSummary
  runout?: Maybe<LegerBalance>
  updatedAt: Scalars['ISO8601DateTime']
}

/** Autogenerated input type of CompleteFinchConnection */
export type CompleteFinchConnectionInput = {
  /** Authorization code returned by Finch Connect */
  authorizationCode: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** ID of the Finch connection record, in our DB, holding the Finch information */
  finchConnectionId: Scalars['Int']
}

/** Autogenerated return type of CompleteFinchConnection. */
export type CompleteFinchConnectionPayload = {
  __typename?: 'CompleteFinchConnectionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** The finch connection that was completed with access token and provider data */
  finchConnection: FinchConnection
  inputErrors: Array<InputError>
}

/** Autogenerated input type of CompleteOnboardingStep */
export type CompleteOnboardingStepInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Type of task to mark as completed */
  dataChange?: InputMaybe<Scalars['String']>
  orgId: Scalars['Int']
  /** Type of step to mark as completed */
  stepType: OnboardingStepType
}

/** Autogenerated return type of CompleteOnboardingStep. */
export type CompleteOnboardingStepPayload = {
  __typename?: 'CompleteOnboardingStepPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of ConfirmTransactions */
export type ConfirmTransactionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Confirm (true) or reject/disconfirm (false) the specified transactions */
  isConfirmed: Scalars['Boolean']
  /** The IDs of the transactions to confirm or reject */
  transactionIds: Array<Scalars['ID']>
}

/** Autogenerated return type of ConfirmTransactions. */
export type ConfirmTransactionsPayload = {
  __typename?: 'ConfirmTransactionsPayload'
  bankingTransactions?: Maybe<Array<BankingTransaction>>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
}

/** The date and value for user confirmation of spend eligibility */
export type ConfirmationStatus = {
  __typename?: 'ConfirmationStatus'
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>
  value: ConfirmationStatusValue
}

export enum ConfirmationStatusValue {
  /** Confirmed eligible */
  Confirmed = 'confirmed',
  /** Eligibility rejected after being confirmed eligible */
  Disconfirmed = 'disconfirmed',
  /** Eligibility has been rejected by user */
  Rejected = 'rejected',
  /** No confirmation has been supplied */
  Unconfirmed = 'unconfirmed',
}

/** Autogenerated input type of ConnectOMNYCard */
export type ConnectOmnyCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  password: Scalars['String']
  username: Scalars['String']
}

/** Autogenerated return type of ConnectOMNYCard. */
export type ConnectOmnyCardPayload = {
  __typename?: 'ConnectOMNYCardPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connection?: Maybe<BankingConnection>
  inputErrors: Array<InputError>
}

export type ContributionBreakdown = {
  __typename?: 'ContributionBreakdown'
  current: Scalars['Int']
  limit: Scalars['Int']
  remaining: Scalars['Int']
  upcoming?: Maybe<Scalars['Int']>
}

/** Autogenerated input type of CreateACHPaymentSource */
export type CreateAchPaymentSourceInput = {
  /** Has the admin pre-accepted ACH mandate? Because this is happening prior to KYB completion, they cannot have *actually* accepted the mandate in Stripe yet */
  acceptedMandate: Scalars['Boolean']
  accountNumber: Scalars['String']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  ownerId: Scalars['Int']
  ownerType: BankableTypeEnum
  routingNumber: Scalars['String']
}

/** Autogenerated return type of CreateACHPaymentSource. */
export type CreateAchPaymentSourcePayload = {
  __typename?: 'CreateACHPaymentSourcePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  paymentMethodConnection?: Maybe<PaymentMethodConnection>
  success: Scalars['Boolean']
}

/** Autogenerated input type of CreateAccountSession */
export type CreateAccountSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  orgId: Scalars['Int']
}

/** Autogenerated return type of CreateAccountSession. */
export type CreateAccountSessionPayload = {
  __typename?: 'CreateAccountSessionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  clientSecret?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of CreateAdminKYCLink */
export type CreateAdminKycLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  orgId: Scalars['Int']
}

/** Autogenerated return type of CreateAdminKYCLink. */
export type CreateAdminKycLinkPayload = {
  __typename?: 'CreateAdminKYCLinkPayload'
  adminKycLink?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of CreateAutoConfirmationMatch */
export type CreateAutoConfirmationMatchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['Int']
  /** The merchant name to auto-confirm */
  merchantName: Scalars['String']
}

/** Autogenerated return type of CreateAutoConfirmationMatch. */
export type CreateAutoConfirmationMatchPayload = {
  __typename?: 'CreateAutoConfirmationMatchPayload'
  autoConfirmationMatch?: Maybe<AutoConfirmationMatch>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee?: Maybe<Employee>
  inputErrors: Array<InputError>
}

/** Autogenerated input type of CreateBillingSetupIntent */
export type CreateBillingSetupIntentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  ownerId: Scalars['Int']
  ownerType: BillableType
  /** Pass a Stripe system ID (e.g. pm_123) of existing US bank account payment method if you want to re-affirm the ACH mandate */
  stripePaymentMethodId?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateBillingSetupIntent. */
export type CreateBillingSetupIntentPayload = {
  __typename?: 'CreateBillingSetupIntentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** used by Stripe.js widget to create a SetupIntent to connect billing */
  clientSecret?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  /** Customer ID for the Stripe account, persisted as billable.billing_system_id */
  stripeAccount?: Maybe<Scalars['String']>
}

/** Autogenerated input type of CreateEmployee */
export type CreateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  /** The ID of the employer to create the employee for, default to the current user's employer */
  employerId?: InputMaybe<Scalars['Int']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  role: EmployeeRole
}

/** Autogenerated return type of CreateEmployee. */
export type CreateEmployeePayload = {
  __typename?: 'CreateEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee?: Maybe<Employee>
  inputErrors: Array<InputError>
}

/** Autogenerated input type of CreateFinchSession */
export type CreateFinchSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Optional display label to distinguish multiple connections for the same organization */
  displayLabel?: InputMaybe<Scalars['String']>
  /** Optional existing finch connection ID to reuse */
  finchConnectionId?: InputMaybe<Scalars['Int']>
  /** Organization ID to create the Finch session for */
  organizationId: Scalars['Int']
}

/** Autogenerated return type of CreateFinchSession. */
export type CreateFinchSessionPayload = {
  __typename?: 'CreateFinchSessionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** The finch connection that was created or updated with session data */
  finchConnection: FinchConnection
  inputErrors: Array<InputError>
}

/** Autogenerated input type of CreateFinicityConnectUrl */
export type CreateFinicityConnectUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['Int']
  institutionPlatformId: Scalars['String']
}

/** Autogenerated return type of CreateFinicityConnectUrl. */
export type CreateFinicityConnectUrlPayload = {
  __typename?: 'CreateFinicityConnectUrlPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connectUrl: Scalars['String']
  employee: Employee
  inputErrors: Array<InputError>
}

/** Autogenerated input type of CreateFinicityConnection */
export type CreateFinicityConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['Int']
  institutionPlatformId: Scalars['String']
}

/** Autogenerated return type of CreateFinicityConnection. */
export type CreateFinicityConnectionPayload = {
  __typename?: 'CreateFinicityConnectionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee: Employee
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of CreateFormResponse */
export type CreateFormResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  complete: Scalars['Boolean']
  formFields: Array<FormFieldInput>
  formName: FormNameEnum
  formVersion: Scalars['Int']
  ownerId: Scalars['Int']
  ownerType: FormResponseOwnerTypeEnum
}

/** Autogenerated return type of CreateFormResponse. */
export type CreateFormResponsePayload = {
  __typename?: 'CreateFormResponsePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  response?: Maybe<Response>
}

/** Autogenerated input type of CreateHostedLinkSession */
export type CreateHostedLinkSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['Int']
  existingConnectionId?: InputMaybe<Scalars['Int']>
  /** The URL to redirect to after the user completes the session */
  returnUri: Scalars['String']
}

/** Autogenerated return type of CreateHostedLinkSession. */
export type CreateHostedLinkSessionPayload = {
  __typename?: 'CreateHostedLinkSessionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee: Employee
  hostedLinkUrl: Scalars['String']
  inputErrors: Array<InputError>
}

/** Autogenerated input type of CreateIssuingSetupIntent */
export type CreateIssuingSetupIntentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  stripeCompanyAccountId: Scalars['Int']
  /** Pass a Stripe system ID (e.g. pm_123) of existing payment method if you want to re-affirm the ACH mandate */
  stripePaymentMethodId?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateIssuingSetupIntent. */
export type CreateIssuingSetupIntentPayload = {
  __typename?: 'CreateIssuingSetupIntentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** used by Stripe.js widget to create a SetupIntent */
  clientSecret?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
}

/** Autogenerated input type of CreateLinkSession */
export type CreateLinkSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['Int']
  existingConnectionId?: InputMaybe<Scalars['Int']>
}

/** Autogenerated return type of CreateLinkSession. */
export type CreateLinkSessionPayload = {
  __typename?: 'CreateLinkSessionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee: Employee
  inputErrors: Array<InputError>
  linkToken: Scalars['String']
}

/** Autogenerated input type of CreateLoginCode */
export type CreateLoginCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The user's mobile phone number */
  tel: Scalars['String']
}

/** Autogenerated return type of CreateLoginCode. */
export type CreateLoginCodePayload = {
  __typename?: 'CreateLoginCodePayload'
  /** The Twilio phone number associated with this user, if any */
  aliceTel?: Maybe<Scalars['String']>
  channel?: Maybe<LoginCodeChannelEnum>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  /** @deprecated This field is no longer required */
  needsPassword: Scalars['Boolean']
  success: Scalars['Boolean']
}

/** Autogenerated input type of CreateMagicLink */
export type CreateMagicLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Number of days until the magic link expires (defaults to system default) */
  expiresInDays?: InputMaybe<Scalars['Int']>
  /** The path the user should be redirected to when using the magic link */
  path: Scalars['String']
  /** Optional query parameters to include in the magic link URL */
  queryParams?: InputMaybe<Scalars['JSON']>
  /** The ID of the user to create the magic link for */
  userId: Scalars['Int']
}

/** Autogenerated input type of CreateMagicLinkLogin */
export type CreateMagicLinkLoginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The user's email address */
  email: Scalars['String']
  /** The path to redirect to after login */
  redirectTo?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateMagicLinkLogin. */
export type CreateMagicLinkLoginPayload = {
  __typename?: 'CreateMagicLinkLoginPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** Number of minutes until the link expires */
  expiresInMinutes?: Maybe<Scalars['Int']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** Autogenerated return type of CreateMagicLink. */
export type CreateMagicLinkPayload = {
  __typename?: 'CreateMagicLinkPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  /** When the magic link expires */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>
  inputErrors: Array<InputError>
  /** The generated magic link URL */
  magicLinkUrl?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

/** Autogenerated input type of CreateOrgAdmin */
export type CreateOrgAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  orgId: Scalars['Int']
  /** The role label to assign to the new user - may be CSV */
  roleLabel: Scalars['String']
}

/** Autogenerated return type of CreateOrgAdmin. */
export type CreateOrgAdminPayload = {
  __typename?: 'CreateOrgAdminPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
  user?: Maybe<User>
}

/** Autogenerated input type of CreateOrganization */
export type CreateOrganizationInput = {
  /** Organization address */
  address?: InputMaybe<AddressInput>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  defaultPayrollPlatformCode?: InputMaybe<Scalars['String']>
  /** Employer Identification Number */
  ein?: InputMaybe<Scalars['String']>
  /** Email of the organization admin user - required if not logged in */
  email?: InputMaybe<Scalars['String']>
  /** First name of the organization admin user - required if not logged in */
  firstName?: InputMaybe<Scalars['String']>
  /** Last name of the organization admin user - required if not logged in */
  lastName?: InputMaybe<Scalars['String']>
  /** Lead name to store on organization. If it matches an existing user's email, they will be assigned as business admin with CSM label */
  leadName?: InputMaybe<Scalars['String']>
  legalName: Scalars['String']
  name: Scalars['String']
  /** Organization telephone number */
  tel?: InputMaybe<Scalars['String']>
  /** Organization website URL */
  websiteUrl?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreateOrganization. */
export type CreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload'
  access?: Maybe<FeatureAccess>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  orgId?: Maybe<Scalars['Int']>
  /** @deprecated Use orgId instead - can only be returned to logged-in users */
  organization?: Maybe<Organization>
}

/** Autogenerated input type of CreatePaymentMethodConnection */
export type CreatePaymentMethodConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The ID of the object to fund */
  ownerId: Scalars['Int']
  /** The type of object to fund */
  ownerType: BankableTypeEnum
  /** The existing PaymentMethod ID to link to the owner */
  paymentMethodId: Scalars['Int']
}

/** Autogenerated return type of CreatePaymentMethodConnection. */
export type CreatePaymentMethodConnectionPayload = {
  __typename?: 'CreatePaymentMethodConnectionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of CreatePaymentMethod */
export type CreatePaymentMethodInput = {
  accountNumber?: InputMaybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The ID of the object to fund */
  ownerId: Scalars['Int']
  /** The type of object to fund */
  ownerType: BankableTypeEnum
  /** The Stripe ID of the payment method to connect */
  paymentMethodId: Scalars['String']
  routingNumber?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of CreatePaymentMethod. */
export type CreatePaymentMethodPayload = {
  __typename?: 'CreatePaymentMethodPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of CreatePhoneLoginCode */
export type CreatePhoneLoginCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The user's mobile phone number */
  tel: Scalars['String']
}

/** Autogenerated return type of CreatePhoneLoginCode. */
export type CreatePhoneLoginCodePayload = {
  __typename?: 'CreatePhoneLoginCodePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  /** @deprecated This field is no longer required */
  needsPassword: Scalars['Boolean']
  success: Scalars['Boolean']
}

/** Autogenerated input type of CreatePhoneVerificationCode */
export type CreatePhoneVerificationCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The user's mobile phone number */
  tel: Scalars['String']
}

/** Autogenerated return type of CreatePhoneVerificationCode. */
export type CreatePhoneVerificationCodePayload = {
  __typename?: 'CreatePhoneVerificationCodePayload'
  /** The Twilio phone number from which we will text this user, if any */
  aliceTel?: Maybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  error?: Maybe<Error>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of CreateSecureTunnelSession */
export type CreateSecureTunnelSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  credentials?: InputMaybe<SecureTunnelSessionCredentialsInput>
  sessionType: SecureTunnelSessionTypeEnum
}

/** Autogenerated return type of CreateSecureTunnelSession. */
export type CreateSecureTunnelSessionPayload = {
  __typename?: 'CreateSecureTunnelSessionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<Scalars['String']>
  inputErrors: Array<InputError>
  secureTunnelSession?: Maybe<SecureTunnelSession>
}

/** Autogenerated input type of CreateTextMessage */
export type CreateTextMessageInput = {
  /** Channel (e.g., twilio, google_voice) */
  channel: TextMessageChannel
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Message direction (inbound or outbound) */
  direction: TextMessageDirection
  /** Message intent (optional) */
  intent?: InputMaybe<Scalars['String']>
  /** The message body */
  message: Scalars['String']
  /** The UUID for tracking this message across systems. For support-agents messages: initially stored as messaging_system_id, then moved to additional_data.tracking_uuid when first Twilio webhook arrives, with Twilio MessageSid taking its place in messaging_system_id. */
  messagingSystemId: Scalars['String']
  /** When the message was sent */
  sentAt: Scalars['ISO8601DateTime']
  /** Detailed information about which LLM agent sent this message and why */
  supportAgentNotes?: InputMaybe<Scalars['String']>
  userId: Scalars['Int']
}

/** Autogenerated return type of CreateTextMessage. */
export type CreateTextMessagePayload = {
  __typename?: 'CreateTextMessagePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  textMessage?: Maybe<TextMessage>
}

/** Autogenerated input type of CreateWorkLocationAssignment */
export type CreateWorkLocationAssignmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The ID of the employer to assign. Provide either employer_id or employer_name, not both. */
  employerId?: InputMaybe<Scalars['Int']>
  /** The marketing friendly name for a new employer. Only used when creating a new employer with employer_name. */
  employerMarketingFriendlyName?: InputMaybe<Scalars['String']>
  /** The name of a new employer to create and assign. Provide either employer_id or employer_name, not both. */
  employerName?: InputMaybe<Scalars['String']>
  /** The ID of the work location to assign the employer to. */
  workLocationId: Scalars['Int']
}

/** Autogenerated return type of CreateWorkLocationAssignment. */
export type CreateWorkLocationAssignmentPayload = {
  __typename?: 'CreateWorkLocationAssignmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  workLocationAssignment?: Maybe<WorkLocationAssignment>
}

/** Autogenerated input type of CreateWorkLocation */
export type CreateWorkLocationInput = {
  /** The address of the workLocation */
  address?: InputMaybe<AddressInput>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The latitude of the workLocation */
  latitude?: InputMaybe<Scalars['Float']>
  /** The longitude of the workLocation */
  longitude?: InputMaybe<Scalars['Float']>
  /** The name of the workLocation */
  name: Scalars['String']
  /** A nickname for the workLocation set by an admin */
  nickname?: InputMaybe<Scalars['String']>
  orgId: Scalars['Int']
}

/** Autogenerated return type of CreateWorkLocation. */
export type CreateWorkLocationPayload = {
  __typename?: 'CreateWorkLocationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
  workLocation: WorkLocation
}

/** A record of a payroll deduction */
export type Deduction = {
  __typename?: 'Deduction'
  amount: Scalars['Int']
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['Int']
  timestamp: Scalars['ISO8601DateTime']
  updatedAt: Scalars['ISO8601DateTime']
}

export type DeductionBreakdown = {
  __typename?: 'DeductionBreakdown'
  actual: Array<Deduction>
  projected: Array<Deduction>
}

/** Autogenerated input type of DeleteAutoConfirmationMatch */
export type DeleteAutoConfirmationMatchInput = {
  autoConfirmationMatchId: Scalars['ID']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of DeleteAutoConfirmationMatch. */
export type DeleteAutoConfirmationMatchPayload = {
  __typename?: 'DeleteAutoConfirmationMatchPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of DeleteBillingSource */
export type DeleteBillingSourceInput = {
  billingSourceId: Scalars['Int']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  ownerId: Scalars['Int']
  ownerType: BillableType
}

/** Autogenerated return type of DeleteBillingSource. */
export type DeleteBillingSourcePayload = {
  __typename?: 'DeleteBillingSourcePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success?: Maybe<Scalars['Boolean']>
}

/** Autogenerated input type of DeleteWorkLocationAssignment */
export type DeleteWorkLocationAssignmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The ID of the employer for the assignment. */
  employerId: Scalars['Int']
  /** The ID of the work location for the assignment. */
  workLocationId: Scalars['Int']
}

/** Autogenerated return type of DeleteWorkLocationAssignment. */
export type DeleteWorkLocationAssignmentPayload = {
  __typename?: 'DeleteWorkLocationAssignmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  deleted: Scalars['Boolean']
  inputErrors: Array<InputError>
}

/** Autogenerated input type of DeleteWorkLocation */
export type DeleteWorkLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The id of the work location to delete */
  workLocationId: Scalars['Int']
}

/** Autogenerated return type of DeleteWorkLocation. */
export type DeleteWorkLocationPayload = {
  __typename?: 'DeleteWorkLocationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  workLocationId: Scalars['Int']
}

/** Autogenerated input type of DisconnectConnection */
export type DisconnectConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  connectionId: Scalars['Int']
}

/** Autogenerated return type of DisconnectConnection. */
export type DisconnectConnectionPayload = {
  __typename?: 'DisconnectConnectionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connection?: Maybe<BankingConnection>
  inputErrors: Array<InputError>
}

export type Employee = {
  __typename?: 'Employee'
  /** Merchant names that are automatically confirmed for this employee */
  autoConfirmationMatches: Array<AutoConfirmationMatch>
  /** Closed pay periods with commuter benefits data */
  closedPayPeriods: Array<PayPeriod>
  /** Current open pay period with commuter benefits (mass_transit, parking) only */
  currentOpenPayPeriod?: Maybe<PayPeriod>
  employer: Employer
  /** @deprecated use paygroupInfo instead */
  employerInfo: EmployerInfo
  employmentStartDate?: Maybe<Scalars['FormattedDate']>
  enrollmentInfo: EmployeeEnrollment
  id: Scalars['Int']
  isCanonical: Scalars['Boolean']
  /** @deprecated use role instead */
  isOrganizationAdmin: Scalars['Boolean']
  ledger?: Maybe<AliceLedger>
  mailingAddress?: Maybe<AddressDisplay>
  paygroupInfo: EmployerInfo
  payrollAddress?: Maybe<AddressDisplay>
  /** @deprecated use user role instead */
  role: EmployeeRole
  /** Roster entry override, if any */
  rosterEntryOverride?: Maybe<RosterEntryOverride>
  spendingConnectionInfo: SpendingConnectionInfo
  spendingInfo: SpendingInfo
  terminationDate?: Maybe<Scalars['FormattedDate']>
  tosAcceptedAt?: Maybe<Scalars['FormattedDate']>
  /** Suggested election and reimbursement on upcoming paycheck, mainly useful for admins doing last paycheck, may be null if employee is no longer enrolled. */
  upcomingPaycheck?: Maybe<UpcomingPaycheck>
  user: User
}

export type EmployeeClosedPayPeriodsArgs = {
  last?: InputMaybe<Scalars['Int']>
}

export type EmployeeEmploymentStartDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type EmployeeTerminationDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type EmployeeTosAcceptedAtArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** The status of an employee's account */
export enum EmployeeAccountStatus {
  Enrolled = 'enrolled',
  Ineligible = 'ineligible',
  NotEnrolled = 'not_enrolled',
  OptedOut = 'opted_out',
  Suspended = 'suspended',
  Terminated = 'terminated',
}

/** The connection type for Employee. */
export type EmployeeConnection = {
  __typename?: 'EmployeeConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployeeEdge>>>
  /** @deprecated Unused and seemingly unneeded */
  employedCount: Scalars['Int']
  enrolledCount: Scalars['Int']
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Employee>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** @deprecated Use the rosterCount field instead */
  reachableCount: Scalars['Int']
  rosterCount: Scalars['Int']
  totalCount: Scalars['Int']
  totalDeductions: Scalars['Float']
  totalSavings: Scalars['Float']
}

/** An edge in a connection. */
export type EmployeeEdge = {
  __typename?: 'EmployeeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Employee>
}

/** data related to the status of an employee's enrollment flow */
export type EmployeeEnrollment = {
  __typename?: 'EmployeeEnrollment'
  accountStatus: EmployeeAccountStatus
  /** Whether the employee may use re-enrollment flow instead of full enrollment */
  canReenroll: Scalars['Boolean']
  /** The reason the employee cannot enroll, if any */
  enrollmentBlocker?: Maybe<EmployeeEnrollmentBlocker>
  enrollmentDate?: Maybe<Scalars['FormattedDate']>
  payrollSystemStatus?: Maybe<EmployeePayrollSystemStatusEnum>
  /** The reason the employee cannot register, if any */
  registrationBlocker?: Maybe<EmployeeRegistrationBlocker>
  /** Whether the employees reimbursements are temporarily suspended */
  reimbursementsSuspended: Scalars['Boolean']
  requirements: EmployeeEnrollmentRequirements
  unenrollmentDate?: Maybe<Scalars['FormattedDate']>
}

/** data related to the status of an employee's enrollment flow */
export type EmployeeEnrollmentEnrollmentDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** data related to the status of an employee's enrollment flow */
export type EmployeeEnrollmentUnenrollmentDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** The reason an employee cannot enroll */
export enum EmployeeEnrollmentBlocker {
  DataRemovalRequest = 'data_removal_request',
  Enrolled = 'enrolled',
  InactiveEmployer = 'inactive_employer',
  Ineligible = 'ineligible',
  MissingCity = 'missing_city',
  NotEnrolledInBenefit = 'not_enrolled_in_benefit',
  OtherAccount = 'other_account',
  Suspended = 'suspended',
  Terminated = 'terminated',
}

/** The status of an employee's enrollment requirement */
export enum EmployeeEnrollmentRequirementStatus {
  /** Blocked */
  Blocked = 'blocked',
  /** Complete */
  Complete = 'complete',
  /** Incomplete */
  Incomplete = 'incomplete',
  /** Pending */
  Pending = 'pending',
}

/** The status of an employee's enrollment requirements */
export type EmployeeEnrollmentRequirements = {
  __typename?: 'EmployeeEnrollmentRequirements'
  /** The status of the employee's employment start date requirement */
  employmentStartDate: EmployeeEnrollmentRequirementStatus
  /** The status of the employee's phone verification requirement */
  phoneVerification: EmployeeEnrollmentRequirementStatus
  /** The status of the employee's registration requirement */
  registration: EmployeeEnrollmentRequirementStatus
  /** The status of the employee's spending connection requirement */
  spendingConnection: EmployeeEnrollmentRequirementStatus
}

/** The status of an employee in payroll */
export enum EmployeePayrollSystemStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Ineligible = 'ineligible',
  PaidLeave = 'paid_leave',
  Terminated = 'terminated',
  UnpaidLeave = 'unpaid_leave',
}

/** Plaid-specific state related to an employee's spending connections */
export type EmployeePlaid = {
  __typename?: 'EmployeePlaid'
  linkSessions?: Maybe<Array<PlaidLinkSession>>
}

/** The reason an employee cannot register */
export enum EmployeeRegistrationBlocker {
  DataRemovalRequest = 'data_removal_request',
  InactiveEmployer = 'inactive_employer',
  Ineligible = 'ineligible',
  MissingCity = 'missing_city',
  OtherAccount = 'other_account',
  Suspended = 'suspended',
  Terminated = 'terminated',
}

/** The name of a role that an employee may have */
export enum EmployeeRole {
  /** @deprecated Use organization_admin instead */
  EmployerAdmin = 'employer_admin',
  NonAdmin = 'non_admin',
  OrganizationAdmin = 'organization_admin',
}

export type Employer = {
  __typename?: 'Employer'
  aliceCardFunding: AliceCardFunding
  billing?: Maybe<Billing>
  employees: EmployeeConnection
  finchConnection?: Maybe<FinchConnection>
  id: Scalars['Int']
  inviteCode: Scalars['String']
  isActive: Scalars['Boolean']
  marketingFriendlyName?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  offboardingDate?: Maybe<Scalars['FormattedDate']>
  organization?: Maybe<Organization>
  payPeriods: PayPeriodConnection
  paygroupConfig?: Maybe<PaygroupConfig>
}

export type EmployerEmployeesArgs = {
  accountStatuses?: InputMaybe<Array<EmployeeAccountStatus>>
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  employerId?: InputMaybe<Scalars['Int']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  searchTerms?: InputMaybe<Array<Scalars['String']>>
}

export type EmployerOffboardingDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type EmployerPayPeriodsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  employerId?: InputMaybe<Scalars['Int']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type EmployerInfo = {
  __typename?: 'EmployerInfo'
  id: Scalars['Int']
  inviteCode: Scalars['String']
  marketingFriendlyName?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  offboardingDate?: Maybe<Scalars['FormattedDate']>
}

export type EmployerInfoOffboardingDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type Enrollment = {
  __typename?: 'Enrollment'
  balance: LegerBalance
  createdAt: Scalars['ISO8601DateTime']
  election: Scalars['Int']
  id: Scalars['Int']
  inboundRollover: Scalars['Int']
  outboundRollover: Scalars['Int']
  planYear: PlanYear
  status?: Maybe<EnrollmentStatus>
  updatedAt: Scalars['ISO8601DateTime']
}

/** Employer information for enrollment landing page */
export type EnrollmentEmployer = {
  __typename?: 'EnrollmentEmployer'
  /** Employer address */
  address?: Maybe<AddressDisplay>
  aliceCardFundingStatus: AliceCardFundingStatus
  enrolledCount: Scalars['Int']
  id: Scalars['Int']
  inviteCode: Scalars['String']
  isActive: Scalars['Boolean']
  marketingFriendlyName?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  reachableCount: Scalars['Int']
}

export type EnrollmentFlyer = {
  __typename?: 'EnrollmentFlyer'
  breakroom?: Maybe<LangUrl>
  businessCard?: Maybe<LangUrl>
  faqs?: Maybe<LangUrl>
  intro?: Maybe<LangUrl>
}

export type EnrollmentLedger = {
  contributions: ContributionBreakdown
  current?: Maybe<LegerBalance>
  deductions: DeductionBreakdown
  enrollments: Array<Enrollment>
  reimbursement: ReimbursementSummary
  runout?: Maybe<LegerBalance>
}

/** Our full suite of enrollment materials for a given location */
export type EnrollmentMaterials = {
  __typename?: 'EnrollmentMaterials'
  enrollmentFlyers?: Maybe<EnrollmentFlyer>
  zippedMaterialsUrl?: Maybe<Scalars['String']>
}

export enum EnrollmentStatus {
  BecameIneligible = 'became_ineligible',
  Defaulted = 'defaulted',
  Enrolled = 'enrolled',
  Ineligible = 'ineligible',
  OptedOut = 'opted_out',
  ReviewedIneligible = 'reviewed_ineligible',
  Unopened = 'unopened',
  Unverified = 'unverified',
  Verified = 'verified',
}

/** An error object with optional code and message */
export type Error = {
  __typename?: 'Error'
  /** Internal only, should not be surfaced to the user. */
  code?: Maybe<Scalars['String']>
  /** Potentially user-facing, so should be user-friendly and actionable. */
  message?: Maybe<Scalars['String']>
}

/** Outstanding access requirements for particular features - nil if the user has full access */
export type FeatureAccess = {
  __typename?: 'FeatureAccess'
  /** The access requirement for the organization admin dashboard */
  orgAdminDashboard: AccessRequirementEnum
}

/** Global feature flags */
export type FeatureFlags = {
  __typename?: 'FeatureFlags'
  /** Whether secure tunnel sessions are enabled globally */
  secureTunnelSessions: Scalars['Boolean']
}

/** File metadata, including host URL */
export type File = {
  __typename?: 'File'
  url?: Maybe<Scalars['String']>
}

export type FinchConnection = {
  __typename?: 'FinchConnection'
  accountId: Scalars['String']
  clientType: Scalars['String']
  companyId: Scalars['String']
  connectionType: Scalars['String']
  createdAt: Scalars['ISO8601DateTime']
  displayLabel?: Maybe<Scalars['String']>
  /** Whether this connection has ever been authenticated (has access token) */
  hasAuthenticatedEver: Scalars['Boolean']
  id: Scalars['Int']
  isActive: Scalars['Boolean']
  products?: Maybe<Array<Scalars['String']>>
  providerId: Scalars['String']
  /** The current session ID for Finch Connect flow (if active) */
  sessionId?: Maybe<Scalars['String']>
  status?: Maybe<FinchConnectionStatus>
  updatedAt: Scalars['ISO8601DateTime']
}

/** Status of the Finch connection */
export enum FinchConnectionStatus {
  Authenticated = 'authenticated',
  NeedsAuthentication = 'needs_authentication',
  ReviewedDisabled = 'reviewed_disabled',
  ReviewedEnabled = 'reviewed_enabled',
}

/** Form field details */
export type FormField = {
  __typename?: 'FormField'
  answer: Scalars['String']
  question: Scalars['String']
  questionId: Scalars['String']
}

/** Input type for a form field */
export type FormFieldInput = {
  answer: Scalars['String']
  question: Scalars['String']
  questionId: Scalars['String']
}

/** Available form types in the system */
export enum FormNameEnum {
  /** Admin user contact details */
  AdminUsers = 'admin_users',
  /** Company profile info */
  CompanyProfile = 'company_profile',
  /** Enrollment materials info */
  EnrollmentMaterials = 'enrollment_materials',
  /** Info to support employee enrollment */
  EnrollmentSuccess = 'enrollment_success',
  /** Information about managing multiple pay groups */
  MultiPayGroups = 'multi_pay_groups',
  /** Payroll operations info */
  PayrollOps = 'payroll_ops',
  /** Upload banking documents */
  SecureBanking = 'secure_banking',
  /** Upload billing documents */
  SecureBilling = 'secure_billing',
  /** Information about shift scheduling system */
  ShiftScheduling = 'shift_scheduling',
}

export enum FormResponseOwnerTypeEnum {
  Org = 'org',
}

export type FundingAccount = BankingAccount | CashPaymentAccount

/** Image metadata, including host URL */
export type Image = {
  __typename?: 'Image'
  thumbnailUrl?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

/** A user-readable error */
export type InputError = {
  __typename?: 'InputError'
  /** Which top-level input argument triggered this error */
  argument: Scalars['String']
  /** Optional - unique code for this error that can be programmatically checked */
  code?: Maybe<Scalars['String']>
  /** A description of the error */
  message: Scalars['String']
}

/** Autogenerated input type of InviteByEmail */
export type InviteByEmailInput = {
  /** Whether the user accepts e-sign consent */
  acceptEsignConsent: Scalars['Boolean']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The user's email address */
  email: Scalars['String']
  /** Optional invite code to validate against user's employer */
  inviteCode: Scalars['String']
}

/** Autogenerated return type of InviteByEmail. */
export type InviteByEmailPayload = {
  __typename?: 'InviteByEmailPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

export type Invoice = {
  __typename?: 'Invoice'
  /**
   * Alice share
   * @deprecated use feeAmount instead
   */
  amount: Scalars['Int']
  /** Date and time the invoice should have been run, or will be run (may be in the future) */
  billDate: Scalars['ISO8601DateTime']
  /** Date and time the invoice was created */
  createdAt: Scalars['ISO8601DateTime']
  /** End date of the lastest invoice item pay period */
  endDate?: Maybe<Scalars['FormattedDate']>
  /** Total fee for services provided by Alice */
  feeAmount: Scalars['Int']
  /** Gross fee for services provided by Alice, before adjustments, discounts, and credit balance is applied */
  grossAmount: Scalars['Int']
  id: Scalars['Int']
  /** Is the invoice overdue? */
  isOverdue: Scalars['Boolean']
  /** List of invoice items */
  items: Array<InvoiceItem>
  /** Name of the owner - org or employer */
  ownerName?: Maybe<Scalars['String']>
  /** Amount already paid */
  paidAmount: Scalars['Int']
  /** Date and time the invoice was paid */
  paidDate?: Maybe<Scalars['ISO8601DateTime']>
  pricingAdjustments: Array<PricingAdjustment>
  /** Invoice refernece number */
  reference?: Maybe<Scalars['String']>
  /** Start date of the earliest invoice item pay period */
  startDate?: Maybe<Scalars['FormattedDate']>
  /** Status of the invoice */
  status: InvoiceStatus
}

export type InvoiceEndDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type InvoiceStartDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** The connection type for Invoice. */
export type InvoiceConnection = {
  __typename?: 'InvoiceConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Invoice>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type InvoiceEdge = {
  __typename?: 'InvoiceEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Invoice>
}

export type InvoiceItem = {
  __typename?: 'InvoiceItem'
  /**
   * Alice share
   * @deprecated use feeAmount instead
   */
  amount: Scalars['Int']
  /** Invoice */
  description?: Maybe<Scalars['String']>
  employeeDeductionTotal: Scalars['Int']
  /** Fee for services provided by Alice */
  feeAmount: Scalars['Int']
  id: Scalars['Int']
}

/** The status of the invoice */
export enum InvoiceStatus {
  /** Autopay failed */
  AutopayFailed = 'autopay_failed',
  /** Failed */
  Failed = 'failed',
  /** Paid */
  Paid = 'paid',
  /** Pending */
  Pending = 'pending',
  /** Refunded */
  Refunded = 'refunded',
  /** Uncollectible */
  Uncollectible = 'uncollectible',
  /** Voided */
  Voided = 'voided',
}

export type LangUrl = {
  __typename?: 'LangUrl'
  enUrl?: Maybe<Scalars['String']>
  esUrl?: Maybe<Scalars['String']>
}

/** The language preference for a user */
export enum LanguagePreference {
  EnUs = 'en_us',
  Es = 'es',
}

/** An account balance amount with usage limitation information */
export type LegerBalance = {
  __typename?: 'LegerBalance'
  /** The available amount to spend with respect to the spending period */
  available: Scalars['Int']
  limitationReason?: Maybe<BalanceLimitation>
  spendingPeriod: TimePeriod
  /** The sum of spending with respect to the spending period */
  spentSoFar: Scalars['Int']
  substantiationDueDate?: Maybe<Scalars['ISO8601DateTime']>
}

/** Autogenerated input type of LoginByPhoneCode */
export type LoginByPhoneCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The login code */
  code: Scalars['String']
  /** The user's mobile phone number */
  tel: Scalars['String']
}

/** Autogenerated return type of LoginByPhoneCode. */
export type LoginByPhoneCodePayload = {
  __typename?: 'LoginByPhoneCodePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errorCode?: Maybe<TelLoginErrorCode>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

export enum LoginCodeChannelEnum {
  /** Sent via email */
  Email = 'email',
  /** Sent via SMS */
  Sms = 'sms',
}

/** Autogenerated input type of Logout */
export type LogoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of Logout. */
export type LogoutPayload = {
  __typename?: 'LogoutPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** Merchant Category Code */
export type Mcc = {
  __typename?: 'MCC'
  /** The label for the MCC code */
  label: Scalars['String']
  /** The MCC code as an integer */
  mcc: Scalars['Int']
}

/** Employee accounting ledger for the current year's mass transit benefit */
export type MassTransitLedger = {
  __typename?: 'MassTransitLedger'
  createdAt: Scalars['ISO8601DateTime']
  /** Balance for current month's spend. Returns the month of whatever day it is today */
  current?: Maybe<LegerBalance>
  id: Scalars['Int']
  updatedAt: Scalars['ISO8601DateTime']
  /** YTD summary of spend for mass_transit benefits */
  yearToDate?: Maybe<LegerBalance>
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Accept an agreement */
  acceptAgreement?: Maybe<AcceptAgreementPayload>
  /** Assign a company representative to a Stripe company account */
  assignCompanyRepresentative?: Maybe<AssignCompanyRepresentativePayload>
  /**
   * Assign a user to an onboarding step
   * @deprecated Use updateOnboardingStep mutation instead
   */
  assignUserToOnboardingStep?: Maybe<AssignUserToStepPayload>
  /** Cancel an Alice Card */
  cancelAliceCard?: Maybe<CancelAliceCardPayload>
  /** Complete a Finch connection by exchanging authorization code for access token */
  completeFinchConnection?: Maybe<CompleteFinchConnectionPayload>
  /**
   * Mark an onboarding step as completed
   * @deprecated Use updateOnboardingStep mutation instead
   */
  completeOnboardingStep?: Maybe<CompleteOnboardingStepPayload>
  /** Confirm or reject transactions for an employee */
  confirmTransactions?: Maybe<ConfirmTransactionsPayload>
  /** Create an account session in Stripe and return client secret */
  createAccountSession?: Maybe<CreateAccountSessionPayload>
  /** Create a link to Stripe's KYC flow for an organization */
  createAdminKycLink?: Maybe<CreateAdminKycLinkPayload>
  /** Save ACH numbers for later payment method creation - may only be used before KYB is complete */
  createAliceCardAchPaymentSource?: Maybe<CreateAchPaymentSourcePayload>
  /** Create and connect a new payment method to fund the specified object */
  createAliceCardPaymentMethod?: Maybe<CreatePaymentMethodPayload>
  /** Connect an existing payment method to fund the specified owner */
  createAliceCardPaymentMethodConnection?: Maybe<CreatePaymentMethodConnectionPayload>
  /** Create a new auto-confirmation match for an employee */
  createAutoConfirmationMatch?: Maybe<CreateAutoConfirmationMatchPayload>
  /** Create a Stripe setup intent to connect a billing source */
  createBillingSetupIntent?: Maybe<CreateBillingSetupIntentPayload>
  /** Create an employee */
  createEmployee?: Maybe<CreateEmployeePayload>
  /** Create a Finch Connect session for organization onboarding */
  createFinchSession?: Maybe<CreateFinchSessionPayload>
  /** Create a Finicity Connect link */
  createFinicityConnectUrl?: Maybe<CreateFinicityConnectUrlPayload>
  /** Create a Finicity connection after a successful Finicity Connect session */
  createFinicityConnection?: Maybe<CreateFinicityConnectionPayload>
  /** Create a form response - replace existing form response for same version of the form */
  createFormResponse?: Maybe<CreateFormResponsePayload>
  /** Create a hosted Plaid link session */
  createHostedLinkSession?: Maybe<CreateHostedLinkSessionPayload>
  /** Create a Stripe setup intent to connect a cards bank account */
  createIssuingSetupIntent?: Maybe<CreateIssuingSetupIntentPayload>
  /** Create a Plaid Link token for native app Link flow */
  createLinkSession?: Maybe<CreateLinkSessionPayload>
  /** Request a login code, delivered via SMS or email */
  createLoginCode?: Maybe<CreateLoginCodePayload>
  /** Create a magic link for a user to access a specific path */
  createMagicLink?: Maybe<CreateMagicLinkPayload>
  /** Request a magic link login */
  createMagicLinkLogin?: Maybe<CreateMagicLinkLoginPayload>
  /** Create a new user and assign them a role in the organization */
  createOrgAdmin?: Maybe<CreateOrgAdminPayload>
  /** Create a new organization with an admin user */
  createOrganization?: Maybe<CreateOrganizationPayload>
  /** Request a phone login code */
  createPhoneLoginCode?: Maybe<CreatePhoneLoginCodePayload>
  /** Request a phone verification code */
  createPhoneVerificationCode?: Maybe<CreatePhoneVerificationCodePayload>
  /** Create a new secure tunnel session */
  createSecureTunnelSession?: Maybe<CreateSecureTunnelSessionPayload>
  /** Create a new text message in a conversation */
  createTextMessage?: Maybe<CreateTextMessagePayload>
  /** Create a new workLocation for an organization */
  createWorkLocation?: Maybe<CreateWorkLocationPayload>
  /** Assign an employer to a work location, creating the employer if needed. */
  createWorkLocationAssignment?: Maybe<CreateWorkLocationAssignmentPayload>
  /** Delete an auto-confirmation match */
  deleteAutoConfirmationMatch?: Maybe<DeleteAutoConfirmationMatchPayload>
  /** Remove a billing source from an organization or employer */
  deleteBillingSource?: Maybe<DeleteBillingSourcePayload>
  /** Delete an employer work location - probably not something a user should be doing too often */
  deleteWorkLocation?: Maybe<DeleteWorkLocationPayload>
  /** Delete an employer's assignment to a work location. */
  deleteWorkLocationAssignment?: Maybe<DeleteWorkLocationAssignmentPayload>
  /** Disconnect an aggregator/OMNY connection */
  disconnectConnection?: Maybe<DisconnectConnectionPayload>
  /** Employee connects an existing OMNY card by providing credentials */
  employeeConnectOmnyCard?: Maybe<ConnectOmnyCardPayload>
  /** Employee requests we ship them a new OMNY card */
  employeeRequestOmnyCard?: Maybe<RequestOmnyCardPayload>
  /** Invite a user by email with optional invite code validation */
  inviteByEmail?: Maybe<InviteByEmailPayload>
  /** Login with a phone code */
  loginByPhoneCode?: Maybe<LoginByPhoneCodePayload>
  /** Logout the current user - clear session */
  logout?: Maybe<LogoutPayload>
  /** Notify an existing organization admin that KYC needs to be completed */
  notifyAdminKyc?: Maybe<NotifyAdminKycPayload>
  /** Record that the employer has completed payroll instructions */
  payrollInstructionsComplete?: Maybe<PayrollInstructionsCompletePayload>
  /**
   * Request an Alice Card
   * @deprecated Use requestAliceCard instead
   */
  provisionAliceCard?: Maybe<RequestAliceCardPayload>
  /** Reconnect OMNY connection by providing updated credentials */
  reconnectOmnyConnection?: Maybe<ReconnectOmnyConnectionPayload>
  /** Re-enroll an employee */
  reenrollEmployee?: Maybe<ReenrollEmployeePayload>
  /** Register an employee */
  registerEmployee?: Maybe<RegisterEmployeePayload>
  /** Report a missing Alice Card */
  reportMissingAliceCard?: Maybe<ReportMissingAliceCardPayload>
  /** Create a 'pending' acceptance by the specified user for an agreement */
  requestAcceptance?: Maybe<RequestAcceptancePayload>
  /** Request an Alice Card */
  requestAliceCard?: Maybe<RequestAliceCardPayload>
  /** Set the banking account for an organization or employer */
  setBankingAccount?: Maybe<SetBankingAccountPayload>
  /** Set the payment card for an organization or paygroup using a Stripe token */
  setPaymentCard?: Maybe<SetPaymentCardPayload>
  /** Submit credentials for a secure tunnel session */
  submitCredentials?: Maybe<SubmitCredentialsPayload>
  /** Submit MFA channel selection for a secure tunnel session */
  submitMfaChannel?: Maybe<SubmitMfaChannelPayload>
  /** Submit MFA token for a secure tunnel session */
  submitMfaToken?: Maybe<SubmitMfaTokenPayload>
  /** Provide termination info about an employee and assert final paycheck has or will run correctly. */
  terminateEmployee?: Maybe<TerminateEmployeePayload>
  /** Update organization-level configuration related to the Alice Card program */
  updateAliceCardProgram?: Maybe<UpdateAliceCardProgramPayload>
  /** Update billing configuration for an organization */
  updateBillingConfig?: Maybe<UpdateBillingConfigPayload>
  /** Update an employee with supported attributes */
  updateEmployee?: Maybe<UpdateEmployeePayload>
  /** Bulk update employees */
  updateEmployees?: Maybe<UpdateEmployeesPayload>
  /** Handle success or failure of a Plaid Link session */
  updateLinkSession?: Maybe<UpdateLinkSessionPayload>
  /** Update OMNY card shipment to mark it received or missing */
  updateOmnyCardShipment?: Maybe<UpdateOmnyCardShipmentPayload>
  /** Update an onboarding step (assign user, mark as started, or mark as complete) */
  updateOnboardingStep?: Maybe<UpdateStepPayload>
  /** Update an organization */
  updateOrganization?: Maybe<UpdateOrganizationPayload>
  /** Update Stripe company account business profile information */
  updateStripeCompanyAccount?: Maybe<UpdateStripeCompanyAccountPayload>
  /** Update a text message */
  updateTextMessage?: Maybe<UpdateTextMessagePayload>
  /** Update a user with supported attributes */
  updateUser?: Maybe<UpdateUserPayload>
  /** Update an organization's work location */
  updateWorkLocation?: Maybe<UpdateWorkLocationPayload>
  /** A simple notification mutation to send a help request message to the support team. */
  userHelpRequest?: Maybe<UserHelpRequestPayload>
  /** Sign up a new user */
  userSignup?: Maybe<UserSignupPayload>
  /** Confirm user's phone number by validating code sent via SMS */
  verifyPhone?: Maybe<VerifyPhonePayload>
}

export type MutationAcceptAgreementArgs = {
  input: AcceptAgreementInput
}

export type MutationAssignCompanyRepresentativeArgs = {
  input: AssignCompanyRepresentativeInput
}

export type MutationAssignUserToOnboardingStepArgs = {
  input: AssignUserToStepInput
}

export type MutationCancelAliceCardArgs = {
  input: CancelAliceCardInput
}

export type MutationCompleteFinchConnectionArgs = {
  input: CompleteFinchConnectionInput
}

export type MutationCompleteOnboardingStepArgs = {
  input: CompleteOnboardingStepInput
}

export type MutationConfirmTransactionsArgs = {
  input: ConfirmTransactionsInput
}

export type MutationCreateAccountSessionArgs = {
  input: CreateAccountSessionInput
}

export type MutationCreateAdminKycLinkArgs = {
  input: CreateAdminKycLinkInput
}

export type MutationCreateAliceCardAchPaymentSourceArgs = {
  input: CreateAchPaymentSourceInput
}

export type MutationCreateAliceCardPaymentMethodArgs = {
  input: CreatePaymentMethodInput
}

export type MutationCreateAliceCardPaymentMethodConnectionArgs = {
  input: CreatePaymentMethodConnectionInput
}

export type MutationCreateAutoConfirmationMatchArgs = {
  input: CreateAutoConfirmationMatchInput
}

export type MutationCreateBillingSetupIntentArgs = {
  input: CreateBillingSetupIntentInput
}

export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput
}

export type MutationCreateFinchSessionArgs = {
  input: CreateFinchSessionInput
}

export type MutationCreateFinicityConnectUrlArgs = {
  input: CreateFinicityConnectUrlInput
}

export type MutationCreateFinicityConnectionArgs = {
  input: CreateFinicityConnectionInput
}

export type MutationCreateFormResponseArgs = {
  input: CreateFormResponseInput
}

export type MutationCreateHostedLinkSessionArgs = {
  input: CreateHostedLinkSessionInput
}

export type MutationCreateIssuingSetupIntentArgs = {
  input: CreateIssuingSetupIntentInput
}

export type MutationCreateLinkSessionArgs = {
  input: CreateLinkSessionInput
}

export type MutationCreateLoginCodeArgs = {
  input: CreateLoginCodeInput
}

export type MutationCreateMagicLinkArgs = {
  input: CreateMagicLinkInput
}

export type MutationCreateMagicLinkLoginArgs = {
  input: CreateMagicLinkLoginInput
}

export type MutationCreateOrgAdminArgs = {
  input: CreateOrgAdminInput
}

export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput
}

export type MutationCreatePhoneLoginCodeArgs = {
  input: CreatePhoneLoginCodeInput
}

export type MutationCreatePhoneVerificationCodeArgs = {
  input: CreatePhoneVerificationCodeInput
}

export type MutationCreateSecureTunnelSessionArgs = {
  input: CreateSecureTunnelSessionInput
}

export type MutationCreateTextMessageArgs = {
  input: CreateTextMessageInput
}

export type MutationCreateWorkLocationArgs = {
  input: CreateWorkLocationInput
}

export type MutationCreateWorkLocationAssignmentArgs = {
  input: CreateWorkLocationAssignmentInput
}

export type MutationDeleteAutoConfirmationMatchArgs = {
  input: DeleteAutoConfirmationMatchInput
}

export type MutationDeleteBillingSourceArgs = {
  input: DeleteBillingSourceInput
}

export type MutationDeleteWorkLocationArgs = {
  input: DeleteWorkLocationInput
}

export type MutationDeleteWorkLocationAssignmentArgs = {
  input: DeleteWorkLocationAssignmentInput
}

export type MutationDisconnectConnectionArgs = {
  input: DisconnectConnectionInput
}

export type MutationEmployeeConnectOmnyCardArgs = {
  input: ConnectOmnyCardInput
}

export type MutationEmployeeRequestOmnyCardArgs = {
  input: RequestOmnyCardInput
}

export type MutationInviteByEmailArgs = {
  input: InviteByEmailInput
}

export type MutationLoginByPhoneCodeArgs = {
  input: LoginByPhoneCodeInput
}

export type MutationLogoutArgs = {
  input: LogoutInput
}

export type MutationNotifyAdminKycArgs = {
  input: NotifyAdminKycInput
}

export type MutationPayrollInstructionsCompleteArgs = {
  input: PayrollInstructionsCompleteInput
}

export type MutationProvisionAliceCardArgs = {
  input: RequestAliceCardInput
}

export type MutationReconnectOmnyConnectionArgs = {
  input: ReconnectOmnyConnectionInput
}

export type MutationReenrollEmployeeArgs = {
  input: ReenrollEmployeeInput
}

export type MutationRegisterEmployeeArgs = {
  input: RegisterEmployeeInput
}

export type MutationReportMissingAliceCardArgs = {
  input: ReportMissingAliceCardInput
}

export type MutationRequestAcceptanceArgs = {
  input: RequestAcceptanceInput
}

export type MutationRequestAliceCardArgs = {
  input: RequestAliceCardInput
}

export type MutationSetBankingAccountArgs = {
  input: SetBankingAccountInput
}

export type MutationSetPaymentCardArgs = {
  input: SetPaymentCardInput
}

export type MutationSubmitCredentialsArgs = {
  input: SubmitCredentialsInput
}

export type MutationSubmitMfaChannelArgs = {
  input: SubmitMfaChannelInput
}

export type MutationSubmitMfaTokenArgs = {
  input: SubmitMfaTokenInput
}

export type MutationTerminateEmployeeArgs = {
  input: TerminateEmployeeInput
}

export type MutationUpdateAliceCardProgramArgs = {
  input: UpdateAliceCardProgramInput
}

export type MutationUpdateBillingConfigArgs = {
  input: UpdateBillingConfigInput
}

export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput
}

export type MutationUpdateEmployeesArgs = {
  input: UpdateEmployeesInput
}

export type MutationUpdateLinkSessionArgs = {
  input: UpdateLinkSessionInput
}

export type MutationUpdateOmnyCardShipmentArgs = {
  input: UpdateOmnyCardShipmentInput
}

export type MutationUpdateOnboardingStepArgs = {
  input: UpdateStepInput
}

export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput
}

export type MutationUpdateStripeCompanyAccountArgs = {
  input: UpdateStripeCompanyAccountInput
}

export type MutationUpdateTextMessageArgs = {
  input: UpdateTextMessageInput
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateWorkLocationArgs = {
  input: UpdateWorkLocationInput
}

export type MutationUserHelpRequestArgs = {
  input: UserHelpRequestInput
}

export type MutationUserSignupArgs = {
  input: UserSignupInput
}

export type MutationVerifyPhoneArgs = {
  input: VerifyPhoneInput
}

/** The delivery channel for the notification */
export enum NotificationChannel {
  Email = 'email',
  PushNotification = 'push_notification',
  Sms = 'sms',
}

/** A notification preference */
export type NotificationPreference = {
  __typename?: 'NotificationPreference'
  channel: NotificationChannel
  enabled: Scalars['Boolean']
  id: Scalars['Int']
  notificationType: NotificationType
}

/** A specific notification preference */
export type NotificationPreferenceInput = {
  /** The channel to update the notification preference for */
  channel: NotificationChannel
  /** Whether the notification should be enabled */
  enabled: Scalars['Boolean']
  notificationType: NotificationType
}

/** The type of notification */
export enum NotificationType {
  InvoiceEvents = 'invoice_events',
  MonthlyFinance = 'monthly_finance',
  PbaWithdrawal = 'pba_withdrawal',
}

/** Autogenerated input type of NotifyAdminKYC */
export type NotifyAdminKycInput = {
  /** The ID of the org admin employee to notify */
  adminId?: InputMaybe<Scalars['Int']>
  /** The ID of the org admin user to notify */
  adminUserId?: InputMaybe<Scalars['Int']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  orgId: Scalars['Int']
}

/** Autogenerated return type of NotifyAdminKYC. */
export type NotifyAdminKycPayload = {
  __typename?: 'NotifyAdminKYCPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  notificationSent?: Maybe<Scalars['Boolean']>
  organization?: Maybe<Organization>
}

/** Activity log entry for onboarding workflow */
export type OnboardingLogMessage = {
  __typename?: 'OnboardingLogMessage'
  /** URL of the resource associated with this action, if any */
  resourceUrl?: Maybe<Scalars['String']>
  /** The step type this log entry relates to */
  stepType: OnboardingStepType
  /** Description of what happened */
  what: Scalars['String']
  /** When the action occurred */
  when: Scalars['ISO8601DateTime']
  /** User who performed the action, if known */
  who?: Maybe<OnboardingLogUser>
}

/** User information for activity log entries */
export type OnboardingLogUser = {
  __typename?: 'OnboardingLogUser'
  /** User's email address */
  email: Scalars['String']
  /** User ID */
  id: Scalars['Int']
  /** User's full name */
  name: Scalars['String']
}

/** Organization-specific state to manage onboarding progress */
export type OnboardingState = {
  __typename?: 'OnboardingState'
  /**
   * Org has submitted Alice Card KYC to Stripe
   * @deprecated use onboardingWorkflow.steps[].tasks[].status instead
   */
  isAliceCardProgramActive: Scalars['Boolean']
  /**
   * Org is receiving or ready to receive services
   * @deprecated use onboardingWorkflow.status instead
   */
  isAlreadyLaunched: Scalars['Boolean']
  /**
   * Org admin confirmed payroll payroll connection
   * @deprecated use onboardingWorkflow.steps[].status instead
   */
  isDoneWithPayrollInstructions: Scalars['Boolean']
  /**
   * Launch date is in the future
   * @deprecated compare locally with organization.commutingLaunchDate
   */
  isLaunchingInFuture: Scalars['Boolean']
  /**
   * Launch date is today
   * @deprecated compare locally with organization.commutingLaunchDate
   */
  isLaunchingToday: Scalars['Boolean']
  /**
   * Alice-confirmed payroll connection
   * @deprecated use onboardingWorkflow.steps[].tasks[].status instead
   */
  isPayrollConnected: Scalars['Boolean']
  /**
   * Org has finished payroll onboarding
   * @deprecated use onboardingWorkflow.steps[].tasks[].status instead
   */
  isPayrollConnectionComplete: Scalars['Boolean']
}

/** Status of an onboarding workflow or step */
export enum OnboardingStatus {
  /** Is blocked and cannot proceed */
  Blocked = 'BLOCKED',
  /** Has been completed */
  Completed = 'COMPLETED',
  /** Currently in progress */
  InProgress = 'IN_PROGRESS',
  /** Has not been started */
  NotStarted = 'NOT_STARTED',
}

/** Individual step in an onboarding workflow */
export type OnboardingStep = {
  __typename?: 'OnboardingStep'
  /** User assigned to this step */
  assignee: User
  /** When the step was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Step ID */
  id: Scalars['Int']
  /** When the step was started */
  startedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Current status of the step */
  status: OnboardingStatus
  /** Type of step */
  stepType: OnboardingStepType
  /** Tasks within this step */
  tasks: Array<OnboardingStepTask>
}

/** Task within an onboarding step */
export type OnboardingStepTask = {
  __typename?: 'OnboardingStepTask'
  /** User assigned to this task */
  assignee: User
  /** When the task was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Task ID */
  id: Scalars['Int']
  /** When the task was started */
  startedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Current status of the step */
  status: OnboardingStatus
  /** Type of task */
  taskType: Scalars['String']
}

/** Type of onboarding step */
export enum OnboardingStepType {
  /** Company profile */
  CompanyProfile = 'COMPANY_PROFILE',
  /** Complete KYC */
  CompleteKyc = 'COMPLETE_KYC',
  /** Connect banking */
  ConnectBanking = 'CONNECT_BANKING',
  /** Connect billing */
  ConnectBilling = 'CONNECT_BILLING',
  /** Connect payroll */
  ConnectPayroll = 'CONNECT_PAYROLL',
  /** Connect shifts */
  ConnectShifts = 'CONNECT_SHIFTS',
  /** Order form */
  OrderForm = 'ORDER_FORM',
  /** Schedule preshift */
  SchedulePreshift = 'SCHEDULE_PRESHIFT',
  /** Set launch date */
  SetLaunchDate = 'SET_LAUNCH_DATE',
  /** Work locations */
  WorkLocations = 'WORK_LOCATIONS',
}

/** Main onboarding workflow for an organization */
export type OnboardingWorkflow = {
  __typename?: 'OnboardingWorkflow'
  /** Activity log for the workflow */
  activityLog: Array<OnboardingLogMessage>
  /** When the workflow was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>
  /** Deadline for completing the workflow */
  deadline?: Maybe<Scalars['ISO8601DateTime']>
  /** Workflow ID */
  id: Scalars['Int']
  /** User who initiated the workflow */
  initiator: User
  /** The date that the organization will notify employees to enroll in Commuting */
  launchDate?: Maybe<Scalars['FormattedDate']>
  /** Organization this workflow belongs to */
  organization: Organization
  /** Current status of the workflow */
  status: OnboardingStatus
  /** Steps in the workflow */
  steps: Array<OnboardingStep>
}

/** Main onboarding workflow for an organization */
export type OnboardingWorkflowLaunchDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type Organization = {
  __typename?: 'Organization'
  /** The organization's acceptance of an agreement */
  acceptance?: Maybe<Acceptance>
  /** Organization address */
  address?: Maybe<AddressDisplay>
  aliceCardFunding: AliceCardFunding
  /** Data about the organization's Alice Card program */
  aliceCardProgram: AliceCardProgram
  billing?: Maybe<Billing>
  /** The business structure of the organization */
  businessStructure?: Maybe<OrganizationBusinessStructure>
  /**
   * The date that the organization will notify employees to enroll in Commuting
   * @deprecated Use launchDate instead
   */
  commutingLaunchDate?: Maybe<Scalars['FormattedDate']>
  /** The date that the organization signed the contract */
  contractSignedOn?: Maybe<Scalars['FormattedDate']>
  /** Default payroll platform for new employers */
  defaultPayrollPlatform?: Maybe<PayrollPlatform>
  /** Employer Identification Number */
  ein?: Maybe<Scalars['String']>
  employees: EmployeeConnection
  /** An employer within the organization, specified by id */
  employer?: Maybe<Employer>
  employers: Array<Maybe<Employer>>
  /** A form response for the specified form name and version */
  formResponse?: Maybe<Response>
  id: Scalars['Int']
  /** Whether the organization has completed onboarding */
  isOnboarded?: Maybe<Scalars['Boolean']>
  /** The date that the organization will notify employees to enroll in Commuting */
  launchDate?: Maybe<Scalars['FormattedDate']>
  /** The legal name of the organization */
  legalName?: Maybe<Scalars['String']>
  logo?: Maybe<Image>
  /** Merchant Category Code (MCC) */
  mcc?: Maybe<Mcc>
  /** The name of the organization (DBA) */
  name?: Maybe<Scalars['String']>
  /** @deprecated use onboardingWorkflow instead */
  onboardingState: OnboardingState
  /** Onboarding workflow for this organization - may be null for already-onboarded organizations */
  onboardingWorkflow?: Maybe<OnboardingWorkflow>
  payPeriod?: Maybe<PayPeriod>
  payPeriods: PayPeriodConnection
  /** Data about a payroll connection for the organization */
  payrollConnection: PayrollConnection
  reports: OrganizationReports
  status: OrganizationStatus
  /** Organization telephone number */
  tel?: Maybe<Scalars['String']>
  /** Organization website URL */
  websiteUrl?: Maybe<Scalars['String']>
  /** A location belonging to the organization, specified by id */
  workLocation?: Maybe<WorkLocation>
  workLocations: Array<Maybe<WorkLocation>>
}

export type OrganizationAcceptanceArgs = {
  accepterId?: InputMaybe<Scalars['Int']>
  type?: InputMaybe<Scalars['String']>
}

export type OrganizationCommutingLaunchDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type OrganizationContractSignedOnArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type OrganizationEmployeesArgs = {
  accountStatuses?: InputMaybe<Array<EmployeeAccountStatus>>
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  employerId?: InputMaybe<Scalars['Int']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  searchTerms?: InputMaybe<Array<Scalars['String']>>
}

export type OrganizationEmployerArgs = {
  id?: InputMaybe<Scalars['Int']>
  inviteCode?: InputMaybe<Scalars['String']>
}

export type OrganizationFormResponseArgs = {
  formName: FormNameEnum
  formVersion: Scalars['Int']
}

export type OrganizationLaunchDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type OrganizationPayPeriodArgs = {
  id: Scalars['Int']
}

export type OrganizationPayPeriodsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  employerId?: InputMaybe<Scalars['Int']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type OrganizationWorkLocationArgs = {
  id: Scalars['Int']
}

/** The business structure of the organization */
export enum OrganizationBusinessStructure {
  /** A business with multiple owners or members that's registered in a US state as a Limited Liability Company (LLC). */
  MultiMemberLlc = 'multi_member_llc',
  /** A business incorporated in a US state that's privately owned. It doesn't have shares that are traded on a public stock exchange. It's also called a closely-held corporation. If you're a single-member LLC that has elected to be treated as a corporation for tax purposes, use this classification. */
  PrivateCorporation = 'private_corporation',
  /** A business entity registered with a US state as a limited liability company (LLC) and that has only one member or owner. */
  SingleMemberLlc = 'single_member_llc',
}

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEdge>>>
  launchedCount: Scalars['Int']
  launchedCountMtd: Scalars['Int']
  launchedEmployeeCount: Scalars['Int']
  launchedEmployeeCountMtd: Scalars['Int']
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
  totalCountMtd: Scalars['Int']
}

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<Organization>
}

export type OrganizationReport = {
  __typename?: 'OrganizationReport'
  description: Scalars['String']
  downloadUrl: Scalars['String']
  id: Scalars['String']
  title: Scalars['String']
}

export type OrganizationReports = {
  __typename?: 'OrganizationReports'
  aliceCardReconciliation: OrganizationReport
  financial: OrganizationReport
  invoices: OrganizationReport
  payPeriods: OrganizationReport
}

/** The status of the organization */
export enum OrganizationStatus {
  Active = 'active',
  Inactive = 'inactive',
  PendingCancellation = 'pending_cancellation',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>
}

/** Employee accounting ledger for the current year's mass transit benefit */
export type ParkingLedger = {
  __typename?: 'ParkingLedger'
  createdAt: Scalars['ISO8601DateTime']
  /** Balance for current month's spend. Returns the month of whatever day it is today */
  current?: Maybe<LegerBalance>
  id: Scalars['Int']
  updatedAt: Scalars['ISO8601DateTime']
  /** YTD summary of spend for parking benefits */
  yearToDate?: Maybe<LegerBalance>
}

/** Pay period for an employer */
export type PayPeriod = {
  __typename?: 'PayPeriod'
  /** The number of employees in question for this pay period. */
  employeeCount: Scalars['Int']
  endDate: Scalars['FormattedDate']
  id: Scalars['Int']
  /** Invoice for the pay period */
  invoice?: Maybe<Invoice>
  /** Employee pay period records */
  payPeriodRecords: Array<PayPeriodRecord>
  payday: Scalars['FormattedDate']
  /** Paygroup info for the pay period */
  paygroupInfo: EmployerInfo
  /** Deadline for submitting payroll data for this pay period */
  payrollDeadline: Scalars['FormattedDate']
  startDate: Scalars['FormattedDate']
  status: PayPeriodStatus
  /** Total employee deductions for the pay period */
  totalEmployeeDeduction: Scalars['Int']
  /** Total amount reimbursed to employees for the pay period */
  totalEmployeeReimbursement: Scalars['Int']
  /** Estimated employee tax savings for the pay period */
  totalEmployeeSavings: Scalars['Int']
  /**
   * Estimated subsidy amount for the pay period
   * @deprecated This is an expensive field to calculate, and is better exposed on invoice
   */
  totalSubsidy: Scalars['Int']
}

/** Pay period for an employer */
export type PayPeriodEndDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** Pay period for an employer */
export type PayPeriodPaydayArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** Pay period for an employer */
export type PayPeriodPayrollDeadlineArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** Pay period for an employer */
export type PayPeriodStartDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** The connection type for PayPeriod. */
export type PayPeriodConnection = {
  __typename?: 'PayPeriodConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PayPeriodEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PayPeriod>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type PayPeriodEdge = {
  __typename?: 'PayPeriodEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<PayPeriod>
}

/** Record of employee's pay period for a particular benefit */
export type PayPeriodRecord = {
  __typename?: 'PayPeriodRecord'
  benefitType?: Maybe<BenefitType>
  /** Amount carried forward from previous pay period in cents */
  carriedBalance?: Maybe<Scalars['Int']>
  /** Amount of deduction in cents */
  deduction?: Maybe<Scalars['Int']>
  employee: Employee
  id: Scalars['Int']
  isPending: Scalars['Boolean']
  /** Pay period associated with the record */
  payPeriod: PayPeriod
  /** Amount of reimbursement in cents */
  reimbursement?: Maybe<Scalars['Int']>
  /** Suggested election amount for this pay period in cents */
  suggestedElection?: Maybe<Scalars['Int']>
  /** Banking transactions associated with this pay period record */
  transactions: Array<BankingTransaction>
  /** Amount that remains unreimbursed in cents */
  unreimbursedAmount?: Maybe<Scalars['Int']>
}

/** The connection type for PayPeriodRecord. */
export type PayPeriodRecordConnection = {
  __typename?: 'PayPeriodRecordConnection'
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PayPeriodRecordEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PayPeriodRecord>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type PayPeriodRecordEdge = {
  __typename?: 'PayPeriodRecordEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node?: Maybe<PayPeriodRecord>
}

export enum PayPeriodStatus {
  Confirmed = 'confirmed',
  Invoiced = 'invoiced',
  NeedsReconciliation = 'needs_reconciliation',
  Paid = 'paid',
  PaidMismatch = 'paid_mismatch',
  PayrollRun = 'payroll_run',
  Pending = 'pending',
}

/** Configuration needed to set up payroll schedule for an organization */
export type PaySchedule = {
  __typename?: 'PaySchedule'
  daysBeforePaydaySubmitted: Scalars['Int']
  lastDayOfMonth?: Maybe<Scalars['Boolean']>
  lastDayOfPayPeriod: Scalars['FormattedDate']
  nextPayday: Scalars['FormattedDate']
  payrollFrequency: PayrollFrequency
  twiceMonthlyPayday1?: Maybe<Scalars['String']>
  twiceMonthlyPayday2?: Maybe<Scalars['String']>
  twiceMonthlyType?: Maybe<TwiceMonthlyType>
}

/** Configuration needed to set up payroll schedule for an organization */
export type PayScheduleLastDayOfPayPeriodArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** Configuration needed to set up payroll schedule for an organization */
export type PayScheduleNextPaydayArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type PaygroupConfig = {
  __typename?: 'PaygroupConfig'
  finchConnection?: Maybe<FinchConnection>
}

/** Card attributes reported by billing system, e.g. Stripe. Full card number is not known to the server. */
export type PaymentCard = {
  __typename?: 'PaymentCard'
  /** ID of the card in the billing system (e.g. Stripe) */
  billingSystemId?: Maybe<Scalars['String']>
  brand: Scalars['String']
  createdAt: Scalars['ISO8601DateTime']
  error?: Maybe<Error>
  expMonth: Scalars['Int']
  expYear: Scalars['Int']
  /** ID of the local Billing::PaymentCard instance */
  id: Scalars['Int']
  last4: Scalars['String']
  updatedAt: Scalars['ISO8601DateTime']
}

/** Card attributes as returned by billing system, e.g. Stripe */
export type PaymentCardInput = {
  brand: Scalars['String']
  exp_month: Scalars['Int']
  exp_year: Scalars['Int']
  /** ID of the card in the billing system */
  id: Scalars['String']
  last4: Scalars['String']
}

/** A payment method for funding an Alice Card program */
export type PaymentMethod = {
  __typename?: 'PaymentMethod'
  descriptor: Scalars['String']
  id?: Maybe<Scalars['Int']>
  last4?: Maybe<Scalars['String']>
  status: PaymentMethodStatus
  /** The ID of the payment method in Stripe, if connected */
  stripeSystemId?: Maybe<Scalars['String']>
}

/** A connection between an employer and a payment method */
export type PaymentMethodConnection = {
  __typename?: 'PaymentMethodConnection'
  id?: Maybe<Scalars['Int']>
  isActive: Scalars['Boolean']
  isCurrent: Scalars['Boolean']
  paymentMethod: PaymentMethod
}

export enum PaymentMethodStatus {
  /** Active */
  Active = 'active',
  /** Error */
  Error = 'error',
  /** Inactive */
  Inactive = 'inactive',
  /** Pending mandate acceptance */
  PendingMandateAcceptance = 'pending_mandate_acceptance',
  /** Info stored locally before Stripe setup is complete */
  PendingSetup = 'pending_setup',
}

/** Attributes used to save payment card info held by Stripe */
export type PaymentTokenInput = {
  card: PaymentCardInput
  id: Scalars['String']
}

/** Data about a payroll connection for an organization */
export type PayrollConnection = {
  __typename?: 'PayrollConnection'
  createdAt: Scalars['ISO8601DateTime']
  /** List of Finch connections linked to this organization */
  finchConnections: Array<FinchConnection>
  id: Scalars['Int']
  /** Whether Finch Connect can be offered to the organization */
  isFinchConnectEnabled: Scalars['Boolean']
  /** @deprecated use is_finch_connect_enabled only */
  isFinchEnabled: Scalars['Boolean']
  payPeriods: PayPeriodConnection
  /** The date and time that the payroll connection was confirmed as complete by Alice */
  payrollConnectedAt?: Maybe<Scalars['ISO8601Date']>
  /** The date and time when the organization admin completed payroll instructions, if known */
  payrollInstructionsCompletedAt?: Maybe<Scalars['ISO8601DateTime']>
  payrollPlatform?: Maybe<PayrollPlatform>
  updatedAt: Scalars['ISO8601DateTime']
}

/** Data about a payroll connection for an organization */
export type PayrollConnectionPayPeriodsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  employerId?: InputMaybe<Scalars['Int']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export enum PayrollFrequency {
  Fortnightly = 'fortnightly',
  Monthly = 'monthly',
  TwicePerMonth = 'twice_per_month',
  TwicePerMonthFixedDay = 'twice_per_month_fixed_day',
  Weekly = 'weekly',
}

/** Autogenerated input type of PayrollInstructionsComplete */
export type PayrollInstructionsCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  orgId: Scalars['Int']
}

/** Autogenerated return type of PayrollInstructionsComplete. */
export type PayrollInstructionsCompletePayload = {
  __typename?: 'PayrollInstructionsCompletePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** A payroll provider used by an organization */
export type PayrollPlatform = {
  __typename?: 'PayrollPlatform'
  code: Scalars['String']
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['Int']
  name: Scalars['String']
  /** Users with partner_executive role for this payroll platform */
  partnerExecutives: Array<PublicUser>
  permitsAdminReports: Scalars['Boolean']
  updatedAt: Scalars['ISO8601DateTime']
}

/** Attributes to update an employee's payroll status */
export type PayrollStatusInput = {
  /** Date on which the final paycheck will or has run */
  finalPaycheckDate?: InputMaybe<Scalars['ISO8601Date']>
  /** Whether the final pay check will be off-cycle or not */
  isOffCycle?: InputMaybe<Scalars['Boolean']>
  /** Employee's actual payroll status */
  payrollSystemStatus?: InputMaybe<EmployeePayrollSystemStatusEnum>
  /** Date on which the employee was or will be terminated */
  terminationDate?: InputMaybe<Scalars['ISO8601Date']>
}

/** Data related to a Plaid Link session */
export type PlaidLinkSession = {
  __typename?: 'PlaidLinkSession'
  bankingConnection?: Maybe<BankingConnection>
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['Int']
  linkToken: Scalars['String']
  status: PlaidLinkSessionStatusEnum
  updatedAt: Scalars['ISO8601DateTime']
}

/** Status of the link session */
export enum PlaidLinkSessionStatusEnum {
  Completed = 'completed',
  Created = 'created',
  Failed = 'failed',
}

/** The plan year for a particular enrollment */
export type PlanYear = {
  __typename?: 'PlanYear'
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['Int']
  period: ClosedTimePeriod
  updatedAt: Scalars['ISO8601DateTime']
}

/** A scheduled preshift event for a work location */
export type PreshiftEvent = {
  __typename?: 'PreshiftEvent'
  /** When the preshift event record was created */
  createdAt: Scalars['ISO8601DateTime']
  /** Preshift event ID */
  id: Scalars['Int']
  /** Email of the person invited to the preshift event */
  inviteeEmail?: Maybe<Scalars['String']>
  /** Name of the person invited to the preshift event */
  inviteeName?: Maybe<Scalars['String']>
  /** When the preshift event is scheduled */
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']>
}

export enum PretaxCategory {
  Dental = 'dental',
  DependentCare = 'dependent_care',
  Healthcare = 'healthcare',
  HealthcarePharmacy = 'healthcare_pharmacy',
  MassTransit = 'mass_transit',
  NotEligible = 'not_eligible',
  Parking = 'parking',
  Vision = 'vision',
}

export type PricingAdjustment = {
  __typename?: 'PricingAdjustment'
  /** Adjustment amount */
  amount: Scalars['Int']
  id: Scalars['Int']
  /** Reason for adjustment */
  reason?: Maybe<Scalars['String']>
}

export enum ProvisionAliceCardScopeEnum {
  Instant = 'instant',
  InstantAndPhysical = 'instant_and_physical',
  Physical = 'physical',
}

export type ProvisionalOrganization = {
  __typename?: 'ProvisionalOrganization'
  address?: Maybe<AddressDisplay>
  id: Scalars['Int']
  isReadyForConversion: Scalars['Boolean']
  isTosAccepted: Scalars['Boolean']
  legalName: Scalars['String']
  organization?: Maybe<Organization>
  paySchedule?: Maybe<PaySchedule>
  payrollPlatform?: Maybe<PayrollPlatform>
}

export type PublicOrganization = {
  __typename?: 'PublicOrganization'
  /** The date that the organization signed the contract */
  contractSignedOn?: Maybe<Scalars['FormattedDate']>
  /** Active employers within the organization for enrollment purposes */
  enrollmentEmployers: Array<EnrollmentEmployer>
  id: Scalars['Int']
  logo?: Maybe<Image>
  name: Scalars['String']
  onboardingState: OnboardingState
  orderFormAcceptance?: Maybe<Acceptance>
  status: OrganizationStatus
}

export type PublicOrganizationContractSignedOnArgs = {
  format?: InputMaybe<Scalars['String']>
}

export type PublicOrganizationOrderFormAcceptanceArgs = {
  accepterId: Scalars['Int']
}

/** Public user information for users */
export type PublicUser = {
  __typename?: 'PublicUser'
  firstName?: Maybe<Scalars['String']>
  id: Scalars['Int']
  lastName?: Maybe<Scalars['String']>
}

export type Query = {
  __typename?: 'Query'
  /** Get all active secure tunnel sessions for the current user */
  activeSecureTunnelSessions: Array<SecureTunnelSession>
  /** Organizations where the user has admin access (business_admin or partner_executive roles) */
  adminOrganizations: OrganizationConnection
  /** Paginated authorization requests for any of the user's Alice Cards */
  aliceCardAuthorizations: AliceCardAuthorizationConnection
  /** Banking connection belonging to the requesting user */
  bankingConnection?: Maybe<BankingConnection>
  /** Banking transaction belonging to the requesting user */
  bankingTransaction: BankingTransaction
  /** Paginated banking transactions belonging to the requesting user's canonical employee */
  bankingTransactions: BankingTransactionConnection
  /** User making the API request, or null if request is anonymous */
  currentUser?: Maybe<User>
  /** The employee specified by id, or the requesting user's canonical employee */
  employee?: Maybe<Employee>
  /** Public enrollment-related employer information */
  enrollmentEmployer?: Maybe<EnrollmentEmployer>
  /** Global feature flags */
  featureFlags: FeatureFlags
  /** The organization specified by id, or the requesting user's canonical org */
  organization?: Maybe<Organization>
  /** Active payroll platforms ordered by name */
  payrollPlatforms: Array<PayrollPlatform>
  /** The public info for the organization */
  publicOrganization?: Maybe<PublicOrganization>
  searchBankingInstitutions?: Maybe<Array<UnifiedInstitution>>
  /** Look up user information by user_id, phone_number, or email (support agents only). Exactly one argument must be provided. */
  userLookup?: Maybe<UserLookup>
  /** Users with a given role */
  usersWithRole?: Maybe<Array<User>>
}

export type QueryAdminOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryAliceCardAuthorizationsArgs = {
  after?: InputMaybe<Scalars['String']>
  aroundDate?: InputMaybe<Scalars['ISO8601Date']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryBankingConnectionArgs = {
  id: Scalars['Int']
}

export type QueryBankingTransactionArgs = {
  id: Scalars['ID']
}

export type QueryBankingTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  confirmationStatus?: InputMaybe<ConfirmationStatusValue>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type QueryEmployeeArgs = {
  id?: InputMaybe<Scalars['Int']>
}

export type QueryEnrollmentEmployerArgs = {
  email?: InputMaybe<Scalars['String']>
  inviteCode?: InputMaybe<Scalars['String']>
}

export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['Int']>
}

export type QueryPublicOrganizationArgs = {
  id?: InputMaybe<Scalars['Int']>
  inviteCode?: InputMaybe<Scalars['String']>
}

export type QuerySearchBankingInstitutionsArgs = {
  name?: InputMaybe<Scalars['String']>
  preferredPlatform?: InputMaybe<BankingConnectionPlatform>
}

export type QueryUserLookupArgs = {
  email?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['Int']>
}

export type QueryUsersWithRoleArgs = {
  resourceId: Scalars['Int']
  roleName: RoleName
  roleType: RoleType
}

/** Autogenerated input type of ReconnectOMNYConnection */
export type ReconnectOmnyConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  connectionId: Scalars['Int']
  password: Scalars['String']
  username: Scalars['String']
}

/** Autogenerated return type of ReconnectOMNYConnection. */
export type ReconnectOmnyConnectionPayload = {
  __typename?: 'ReconnectOMNYConnectionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connection?: Maybe<BankingConnection>
  inputErrors: Array<InputError>
}

/** Autogenerated input type of ReenrollEmployee */
export type ReenrollEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['Int']
}

/** Autogenerated return type of ReenrollEmployee. */
export type ReenrollEmployeePayload = {
  __typename?: 'ReenrollEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of RegisterEmployee */
export type RegisterEmployeeInput = {
  /** Accept Alice Card TOS and enroll (might not provision automatically) */
  acceptAliceCardTos?: InputMaybe<Scalars['Boolean']>
  /** Accept terms and esign */
  acceptTermsAndEsign: Scalars['Boolean']
  /** Birthdate - required for all Alice Card provisioning */
  birthdate?: InputMaybe<Scalars['ISO8601Date']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The user's e-mail */
  email: Scalars['String']
  /** Employment start date */
  employmentStartDate?: InputMaybe<Scalars['ISO8601Date']>
  /** First name */
  firstName: Scalars['String']
  /** The invite code for the employer */
  inviteCode: Scalars['String']
  /** preferred language code as enum, e.g. 'en_us' or 'es' */
  language?: InputMaybe<LanguagePreference>
  /** Last name */
  lastName: Scalars['String']
  /** Mailing address - verification will be attempted if supplied */
  mailingAddress?: InputMaybe<AddressInput>
  /** Password */
  password?: InputMaybe<Scalars['String']>
  /** Password confirmation */
  passwordConfirmation?: InputMaybe<Scalars['String']>
  /** Preferred name */
  preferredName?: InputMaybe<Scalars['String']>
  /** ID of referring employee */
  referredBy?: InputMaybe<Scalars['Int']>
  /** The user's mobile phone number */
  tel: Scalars['String']
  utmParams?: InputMaybe<UtmParams>
}

/** Autogenerated return type of RegisterEmployee. */
export type RegisterEmployeePayload = {
  __typename?: 'RegisterEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee?: Maybe<Employee>
  inputErrors: Array<InputError>
}

/** A record of this transaction being partly or full reimbursed */
export type Reimbursement = {
  __typename?: 'Reimbursement'
  amount: Scalars['Int']
  date: Scalars['ISO8601DateTime']
}

export type ReimbursementClaim = {
  __typename?: 'ReimbursementClaim'
  approvalStatus: ReimbursementClaimApprovalStatus
  claimDocuments: Array<ReimbursementClaimDocument>
  id: Scalars['Int']
  reviewedAt?: Maybe<Scalars['FormattedDate']>
  reviewerNote?: Maybe<Scalars['String']>
}

export type ReimbursementClaimReviewedAtArgs = {
  format?: InputMaybe<Scalars['String']>
}

export enum ReimbursementClaimApprovalStatus {
  Approved = 'approved',
  ApprovedRequiresManualReimbursement = 'approved_requires_manual_reimbursement',
  Denied = 'denied',
  NotRequired = 'not_required',
  Pending = 'pending',
}

/** Claim document, with image */
export type ReimbursementClaimDocument = {
  __typename?: 'ReimbursementClaimDocument'
  createdAt: Scalars['ISO8601DateTime']
  id: Scalars['Int']
  image?: Maybe<Image>
}

/** Information about the state of reimbursement for this transaction */
export type ReimbursementStatus = {
  __typename?: 'ReimbursementStatus'
  isFullyReimbursed: Scalars['Boolean']
  reimbursements: Array<Reimbursement>
}

export type ReimbursementSummary = {
  __typename?: 'ReimbursementSummary'
  confirmedSpend: Scalars['Int']
  savedSoFarEstimate: Scalars['Int']
}

/** Autogenerated input type of ReportMissingAliceCard */
export type ReportMissingAliceCardInput = {
  aliceCardId: Scalars['Int']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of ReportMissingAliceCard. */
export type ReportMissingAliceCardPayload = {
  __typename?: 'ReportMissingAliceCardPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of RequestAcceptance */
export type RequestAcceptanceInput = {
  accepterId: Scalars['Int']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  ownerId: Scalars['Int']
  /** The type identifier of the agreement to accept */
  type?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of RequestAcceptance. */
export type RequestAcceptancePayload = {
  __typename?: 'RequestAcceptancePayload'
  acceptance?: Maybe<Acceptance>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
}

/** Autogenerated input type of RequestAliceCard */
export type RequestAliceCardInput = {
  /** The birthdate of the employee, if not already known */
  birthdate?: InputMaybe<Scalars['ISO8601Date']>
  cardTypesRequested?: InputMaybe<CardRequestTypeEnum>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The mailing address for the card, if different from employee's current address */
  mailingAddress?: InputMaybe<AddressInput>
  /** Acceptance of the Alice Card TOS, if not previously accepted */
  tosAccepted?: InputMaybe<Scalars['Boolean']>
}

/** Autogenerated return type of RequestAliceCard. */
export type RequestAliceCardPayload = {
  __typename?: 'RequestAliceCardPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee?: Maybe<Employee>
  inputErrors: Array<InputError>
}

/** Autogenerated input type of RequestOMNYCard */
export type RequestOmnyCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of RequestOMNYCard. */
export type RequestOmnyCardPayload = {
  __typename?: 'RequestOMNYCardPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connection?: Maybe<BankingConnection>
  inputErrors: Array<InputError>
}

/** Form response details */
export type Response = {
  __typename?: 'Response'
  complete: Scalars['Boolean']
  formFields: Array<FormField>
  formName: FormNameEnum
  formVersion: Scalars['Int']
  id: Scalars['Int']
  lastEditedByUser: User
}

/** A role assigned to a user for a resource */
export type Role = {
  __typename?: 'Role'
  id: Scalars['Int']
  label?: Maybe<Scalars['String']>
  resourceDisplayInfo: RoleResource
  roleName: RoleName
}

/** The name of a role */
export enum RoleName {
  BusinessAdmin = 'business_admin',
  PartnerExecutive = 'partner_executive',
}

/** Summary of the resource a role is assigned to */
export type RoleResource = {
  __typename?: 'RoleResource'
  /** The display name of the resource, if available */
  displayName?: Maybe<Scalars['String']>
  id: Scalars['Int']
  /** The type of the resource */
  resourceType: RoleResourceType
}

/** The type of resource a role is assigned to */
export enum RoleResourceType {
  Organization = 'Organization',
  PayrollPlatform = 'PayrollPlatform',
}

/** The type of role (class name) */
export enum RoleType {
  OrganizationRole = 'OrganizationRole',
  PayrollPlatformRole = 'PayrollPlatformRole',
}

export type RosterEntryOverride = {
  __typename?: 'RosterEntryOverride'
  payrollSystemStatus?: Maybe<EmployeePayrollSystemStatusEnum>
  terminationDate?: Maybe<Scalars['FormattedDate']>
}

export type RosterEntryOverrideTerminationDateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** A secure tunnel session for operator assistance */
export type SecureTunnelSession = {
  __typename?: 'SecureTunnelSession'
  claimedAt?: Maybe<Scalars['ISO8601DateTime']>
  completedAt?: Maybe<Scalars['ISO8601DateTime']>
  createdAt: Scalars['ISO8601DateTime']
  expiresAt: Scalars['ISO8601DateTime']
  id: Scalars['ID']
  sessionType: SecureTunnelSessionTypeEnum
  state: SecureTunnelSessionStateEnum
  updatedAt: Scalars['ISO8601DateTime']
  userId: Scalars['String']
}

/** Input for secure tunnel session credentials */
export type SecureTunnelSessionCredentialsInput = {
  /** Company ID if required */
  companyId?: InputMaybe<Scalars['String']>
  /** Password for the system */
  password: Scalars['String']
  /** Username for the system */
  username: Scalars['String']
}

/** The MFA channel for a secure tunnel session */
export enum SecureTunnelSessionMfaChannelEnum {
  Authenticator = 'AUTHENTICATOR',
  Email = 'EMAIL',
  Text = 'TEXT',
}

/** The state of a secure tunnel session */
export enum SecureTunnelSessionStateEnum {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  CredentialsAccepted = 'CREDENTIALS_ACCEPTED',
  CredentialsRejected = 'CREDENTIALS_REJECTED',
  CredentialsSubmitted = 'CREDENTIALS_SUBMITTED',
  Expired = 'EXPIRED',
  MfaChannelRequired = 'MFA_CHANNEL_REQUIRED',
  MfaRequired = 'MFA_REQUIRED',
  MfaSubmitted = 'MFA_SUBMITTED',
  PendingCredentials = 'PENDING_CREDENTIALS',
  Processing = 'PROCESSING',
}

/** The type of secure tunnel session */
export enum SecureTunnelSessionTypeEnum {
  Other = 'OTHER',
  Payroll = 'PAYROLL',
  Shifts = 'SHIFTS',
}

/** Autogenerated input type of SetBankingAccount */
export type SetBankingAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  ownerId: Scalars['Int']
  ownerType: BillableType
  paymentMethodId: Scalars['String']
  routingNumber?: InputMaybe<Scalars['String']>
  verificationUrl?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of SetBankingAccount. */
export type SetBankingAccountPayload = {
  __typename?: 'SetBankingAccountPayload'
  bankingAccount?: Maybe<BankingAccount>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
}

/** Autogenerated input type of SetPaymentCard */
export type SetPaymentCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  ownerId: Scalars['Int']
  ownerType: BillableType
  token: PaymentTokenInput
}

/** Autogenerated return type of SetPaymentCard. */
export type SetPaymentCardPayload = {
  __typename?: 'SetPaymentCardPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  paymentCard?: Maybe<PaymentCard>
}

export type SpendEligibility = {
  __typename?: 'SpendEligibility'
  autoConfirmedAt?: Maybe<Scalars['ISO8601DateTime']>
  confirmationStatus: ConfirmationStatus
  confirmedPartialAmount?: Maybe<Scalars['Int']>
  isDisconfirmable?: Maybe<Scalars['Boolean']>
  pretaxCategory: PretaxCategory
}

/** Spending connection information for an employee */
export type SpendingConnectionInfo = {
  __typename?: 'SpendingConnectionInfo'
  aliceCard?: Maybe<AliceCard>
  /** The employee's primary Alice Card account */
  aliceCardAccount?: Maybe<AliceCardAccount>
  /** The employee's Alice Card accounts - generally should prefer aliceCardAccount */
  aliceCardAccounts?: Maybe<Array<AliceCardAccount>>
  balanceInfo: BalanceInfo
  bankingConnections?: Maybe<Array<BankingConnection>>
  hasAcceptedAliceCardTos: Scalars['Boolean']
  hasRequestedAliceCard: Scalars['Boolean']
  plaid: EmployeePlaid
}

/** Spending connection information for an employee */
export type SpendingConnectionInfoAliceCardArgs = {
  id: Scalars['Int']
}

/** Spending information for an employee */
export type SpendingInfo = {
  __typename?: 'SpendingInfo'
  /** Whether the employee has any auto-confirmed transactions in the last 30 days */
  hasRecentAutoConfirmedTxns: Scalars['Boolean']
  /** The total estimated pre-tax savings for the employee */
  totalEstimatedPretaxSavings?: Maybe<Scalars['Int']>
}

/** An organization's Company Account that records its Alice Card data */
export type StripeCompanyAccount = {
  __typename?: 'StripeCompanyAccount'
  accountStatus: StripeCompanyAccountStatusEnum
  /** Business profile information stored in Stripe */
  businessProfile?: Maybe<BusinessProfile>
  /** The user assigned as the company representative for this Stripe account */
  companyRepresentative?: Maybe<User>
  /** The list of requirements that are currently due for this account */
  currentlyDueRequirements: Array<Scalars['String']>
  id: Scalars['Int']
  /** The list of requirements that are pending verification by Stripe */
  requirementsPendingVerification: Array<Scalars['String']>
  /**
   * The connected account ID provided by Stripe
   * @deprecated Use `stripe_financial_account_id` instead
   */
  stripeAccountId?: Maybe<Scalars['String']>
  /** The connected account ID provided by Stripe, acct_xxx */
  stripeConnectedAccountId?: Maybe<Scalars['String']>
  /** The financial account ID provided by Stripe, fa_xxx */
  stripeFinancialAccountId?: Maybe<Scalars['String']>
  /** used by Stripe.js widget to create a SetupIntent */
  stripeSetupIntentSecret?: Maybe<Scalars['String']>
}

export enum StripeCompanyAccountStatusEnum {
  /** Active */
  Active = 'active',
  /** Deactivated */
  Deactivated = 'deactivated',
  /** Not submitted */
  NotSubmitted = 'not_submitted',
  /** Submitted */
  Submitted = 'submitted',
}

/** A Stripe Card's digital wallet configuration */
export type StripeWallets = {
  __typename?: 'StripeWallets'
  applePay?: Maybe<WalletInfo>
  googlePay?: Maybe<WalletInfo>
  primaryAccountIdentifier?: Maybe<Scalars['String']>
}

/** Autogenerated input type of SubmitCredentials */
export type SubmitCredentialsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  credentials: SecureTunnelSessionCredentialsInput
  sessionId: Scalars['ID']
}

/** Autogenerated return type of SubmitCredentials. */
export type SubmitCredentialsPayload = {
  __typename?: 'SubmitCredentialsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<Scalars['String']>
  inputErrors: Array<InputError>
  secureTunnelSession?: Maybe<SecureTunnelSession>
}

/** Autogenerated input type of SubmitMfaChannel */
export type SubmitMfaChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  mfaChannel: SecureTunnelSessionMfaChannelEnum
  sessionId: Scalars['ID']
}

/** Autogenerated return type of SubmitMfaChannel. */
export type SubmitMfaChannelPayload = {
  __typename?: 'SubmitMfaChannelPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<Scalars['String']>
  inputErrors: Array<InputError>
  secureTunnelSession?: Maybe<SecureTunnelSession>
}

/** Autogenerated input type of SubmitMfaToken */
export type SubmitMfaTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  sessionId: Scalars['ID']
  token: Scalars['String']
}

/** Autogenerated return type of SubmitMfaToken. */
export type SubmitMfaTokenPayload = {
  __typename?: 'SubmitMfaTokenPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  errors: Array<Scalars['String']>
  inputErrors: Array<InputError>
  secureTunnelSession?: Maybe<SecureTunnelSession>
}

/** The type of tel-based login error */
export enum TelLoginErrorCode {
  AccountLocked = 'account_locked',
  ExpiredCode = 'expired_code',
  InvalidCode = 'invalid_code',
  InvalidPassword = 'invalid_password',
  InvalidTel = 'invalid_tel',
}

/** A telephone number with metadata */
export type Telephone = {
  __typename?: 'Telephone'
  countryCode: Scalars['String']
  /** Whether a confirmation code has been sent and is still valid */
  isConfirmationCodeSent?: Maybe<Scalars['Boolean']>
  /** Confirmed as user's number through SMS */
  isSmsConfirmed?: Maybe<Scalars['Boolean']>
  /** Number verified by phone lookup service */
  isVerified?: Maybe<Scalars['Boolean']>
  /** Subscriber number, without country code */
  nationalNumber: Scalars['String']
}

/** Autogenerated input type of TerminateEmployee */
export type TerminateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['Int']
  /** Date on which the final paycheck will or has run. */
  finalPaycheckDate: Scalars['ISO8601Date']
  /** Whether the final pay check will be off-cycle or not. */
  isOffCycle: Scalars['Boolean']
  /** Date on which the employee was or will be terminated */
  terminationDate: Scalars['ISO8601Date']
}

/** Autogenerated return type of TerminateEmployee. */
export type TerminateEmployeePayload = {
  __typename?: 'TerminateEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** A text message in a conversation */
export type TextMessage = {
  __typename?: 'TextMessage'
  channel: TextMessageChannel
  deliveryStatus?: Maybe<TextMessageDeliveryStatus>
  direction: TextMessageDirection
  id: Scalars['Int']
  intent?: Maybe<Scalars['String']>
  message: Scalars['String']
  /** The system ID for tracking this message (UUID for support-agents, MessageSid for Twilio) */
  messagingSystemId?: Maybe<Scalars['String']>
  partOfAiConversation: Scalars['Boolean']
  sentAt: Scalars['ISO8601DateTime']
  supportAgentNotes?: Maybe<Scalars['String']>
  threadId: Scalars['Int']
}

/** The channel used for text messaging */
export enum TextMessageChannel {
  Customerio = 'customerio',
  GoogleVoice = 'google_voice',
  Sendhub = 'sendhub',
  SupportAgent = 'support_agent',
  Twilio = 'twilio',
}

/** The delivery status of a text message */
export enum TextMessageDeliveryStatus {
  /** Message was delivered */
  Delivered = 'delivered',
  /** Message delivery failed */
  Failed = 'failed',
  /** Message is in transit */
  Queued = 'queued',
  /** Message delivery failed */
  QueueingFailure = 'queueing_failure',
  /** Message is in transit */
  Sent = 'sent',
  /** Message delivery failed */
  Undelivered = 'undelivered',
}

/** The direction of a text message (inbound or outbound) */
export enum TextMessageDirection {
  Inbound = 'inbound',
  Outbound = 'outbound',
}

/** A representation of a time duration with a fixed starting date and time - may be infinite */
export type TimePeriod = {
  __typename?: 'TimePeriod'
  endDate?: Maybe<Scalars['ISO8601DateTime']>
  startDate: Scalars['ISO8601DateTime']
}

export enum TwiceMonthlyType {
  FifteenthAndLast = 'fifteenth_and_last',
  Other = 'other',
}

/** A unified institution is a single institution that may be represented in multiple platforms */
export type UnifiedInstitution = {
  __typename?: 'UnifiedInstitution'
  id: Scalars['Int']
  logoUrl?: Maybe<Scalars['String']>
  name: Scalars['String']
  platformId: Scalars['String']
  preferredPlatform: BankingConnectionPlatform
}

/** Pay period record data for the upcoming paycheck */
export type UpcomingPaycheck = {
  __typename?: 'UpcomingPaycheck'
  massTransitDeduction: Scalars['Int']
  massTransitReimbursement: Scalars['Int']
  parkingDeduction: Scalars['Int']
  parkingReimbursement: Scalars['Int']
}

/** Autogenerated input type of UpdateAliceCardProgram */
export type UpdateAliceCardProgramInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Whether the organization should be funded at the org level or the paygroup level */
  hasUnifiedBanking?: InputMaybe<Scalars['Boolean']>
  orgId: Scalars['Int']
}

/** Autogenerated return type of UpdateAliceCardProgram. */
export type UpdateAliceCardProgramPayload = {
  __typename?: 'UpdateAliceCardProgramPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of UpdateBillingConfig */
export type UpdateBillingConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Whether the organization should be billed at the org level or the paygroup level */
  hasUnifiedBilling?: InputMaybe<Scalars['Boolean']>
  orgId: Scalars['Int']
}

/** Autogenerated return type of UpdateBillingConfig. */
export type UpdateBillingConfigPayload = {
  __typename?: 'UpdateBillingConfigPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of UpdateEmployee */
export type UpdateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['Int']
  /** Employment start date */
  employmentStartDate?: InputMaybe<Scalars['ISO8601Date']>
  /** Mailing address, with optional verification check */
  mailingAddress?: InputMaybe<AddressInput>
  /** employee payroll status override */
  payrollStatus?: InputMaybe<PayrollStatusInput>
}

/** Autogenerated return type of UpdateEmployee. */
export type UpdateEmployeePayload = {
  __typename?: 'UpdateEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee?: Maybe<Employee>
  inputErrors: Array<InputError>
}

/** Autogenerated input type of UpdateEmployees */
export type UpdateEmployeesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeIds: Array<Scalars['Int']>
  role?: InputMaybe<EmployeeRole>
}

/** Autogenerated return type of UpdateEmployees. */
export type UpdateEmployeesPayload = {
  __typename?: 'UpdateEmployeesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** Autogenerated input type of UpdateLinkSession */
export type UpdateLinkSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  employeeId: Scalars['Int']
  failed?: InputMaybe<Scalars['Boolean']>
  linkToken: Scalars['String']
  publicToken?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UpdateLinkSession. */
export type UpdateLinkSessionPayload = {
  __typename?: 'UpdateLinkSessionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  employee: Employee
  inputErrors: Array<InputError>
}

/** Autogenerated input type of UpdateOMNYCardShipment */
export type UpdateOmnyCardShipmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  shipmentId: Scalars['Int']
  status: CardShipmentStatus
}

/** Autogenerated return type of UpdateOMNYCardShipment. */
export type UpdateOmnyCardShipmentPayload = {
  __typename?: 'UpdateOMNYCardShipmentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  connection?: Maybe<BankingConnection>
  inputErrors: Array<InputError>
}

/** Autogenerated input type of UpdateOrganization */
export type UpdateOrganizationInput = {
  /** Organization address */
  address?: InputMaybe<AddressInput>
  /** The business structure of the organization */
  businessStructure?: InputMaybe<OrganizationBusinessStructure>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** FK to default payroll platform */
  defaultPayrollPlatformId?: InputMaybe<Scalars['Int']>
  /** Employer Identification Number */
  ein?: InputMaybe<Scalars['String']>
  /** The date that the organization will notify employees to enroll in Commuting */
  launchDate?: InputMaybe<Scalars['ISO8601Date']>
  /** Merchant Category Code (MCC) as an integer */
  mcc?: InputMaybe<Scalars['Int']>
  orgId: Scalars['Int']
  /** Organization telephone number */
  tel?: InputMaybe<Scalars['String']>
  /** Organization website URL */
  websiteUrl?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UpdateOrganization. */
export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of UpdateStep */
export type UpdateStepInput = {
  /** ID of user to assign to the step */
  assigneeId?: InputMaybe<Scalars['Int']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Mark the step as complete */
  isComplete?: InputMaybe<Scalars['Boolean']>
  /** Mark the step as started */
  isStarted?: InputMaybe<Scalars['Boolean']>
  orgId: Scalars['Int']
  /** Type of step to update */
  stepType: OnboardingStepType
}

/** Autogenerated return type of UpdateStep. */
export type UpdateStepPayload = {
  __typename?: 'UpdateStepPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  /** The updated onboarding step */
  onboardingStep?: Maybe<OnboardingStep>
  organization?: Maybe<Organization>
}

/** Autogenerated input type of UpdateStripeCompanyAccount */
export type UpdateStripeCompanyAccountInput = {
  /** Annual revenue in cents (must be provided with fiscal_year_end) */
  annualRevenue?: InputMaybe<Scalars['BigInt']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Fiscal year end date in ISO8601 format (must be provided with annual_revenue) */
  fiscalYearEnd?: InputMaybe<Scalars['ISO8601Date']>
  orgId: Scalars['Int']
}

/** Autogenerated return type of UpdateStripeCompanyAccount. */
export type UpdateStripeCompanyAccountPayload = {
  __typename?: 'UpdateStripeCompanyAccountPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  organization?: Maybe<Organization>
  success: Scalars['Boolean']
}

/** Autogenerated input type of UpdateTextMessage */
export type UpdateTextMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Message intent (optional) */
  intent?: InputMaybe<Scalars['String']>
  /** Detailed information about which LLM agent sent this message and why */
  supportAgentNotes?: InputMaybe<Scalars['String']>
  /** The ID of the text message to update */
  textMessageId: Scalars['Int']
}

/** Autogenerated return type of UpdateTextMessage. */
export type UpdateTextMessagePayload = {
  __typename?: 'UpdateTextMessagePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  textMessage?: Maybe<TextMessage>
}

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  birthdate?: InputMaybe<Scalars['ISO8601Date']>
  /** Block or unblock AI support for this user */
  blockAiSupport?: InputMaybe<Scalars['Boolean']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The user's preferred language */
  languagePreference?: InputMaybe<LanguagePreference>
  /** User notification preference assignments */
  notificationPreferences?: InputMaybe<Array<NotificationPreferenceInput>>
  userId: Scalars['Int']
}

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  user?: Maybe<User>
}

/** Autogenerated input type of UpdateWorkLocation */
export type UpdateWorkLocationInput = {
  /** The address of the workLocation */
  address?: InputMaybe<AddressInput>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  /** The latitude of the workLocation */
  latitude?: InputMaybe<Scalars['Float']>
  /** The longitude of the workLocation */
  longitude?: InputMaybe<Scalars['Float']>
  /** The name of the workLocation */
  name?: InputMaybe<Scalars['String']>
  /** The user-provided nickname of the workLocation */
  nickname?: InputMaybe<Scalars['String']>
}

/** Autogenerated return type of UpdateWorkLocation. */
export type UpdateWorkLocationPayload = {
  __typename?: 'UpdateWorkLocationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  id: Scalars['Int']
  inputErrors: Array<InputError>
}

/** An individual person who uses Alice */
export type User = {
  __typename?: 'User'
  access: FeatureAccess
  /** User's address */
  address?: Maybe<AddressDisplay>
  /** User's birthdate */
  birthdate?: Maybe<Scalars['FormattedDate']>
  email?: Maybe<Scalars['String']>
  /** All employee instances associated with the user - prefer root-level canonical 'employee' query */
  employees?: Maybe<Array<Employee>>
  firstName?: Maybe<Scalars['String']>
  /** Has the user set their own password */
  hasDummyPassword: Scalars['Boolean']
  helpScoutSecureBeaconToken?: Maybe<Scalars['String']>
  id: Scalars['Int']
  identityVerification?: Maybe<Verification>
  /** Is AI support currently blocked for this user */
  isAiSupportBlocked: Scalars['Boolean']
  /** Has the user has confirmed their email address */
  isEmailConfirmed: Scalars['Boolean']
  /** The user's preferred language */
  languagePreference: LanguagePreference
  lastName?: Maybe<Scalars['String']>
  notificationPreferences: Array<NotificationPreference>
  preferredName?: Maybe<Scalars['String']>
  /** Provisional organizations that the user has created */
  provisionalOrganizations: Array<ProvisionalOrganization>
  /** The role specified for the type and resource ID specified */
  role: Role
  /** All roles associated with the user session */
  roles: Array<Role>
  /** Last 4 digits of the user's Social Security Number */
  ssnLast4?: Maybe<Scalars['String']>
  tel?: Maybe<Telephone>
  /** Text messages in the user's conversation */
  textMessages: Array<TextMessage>
}

/** An individual person who uses Alice */
export type UserBirthdateArgs = {
  format?: InputMaybe<Scalars['String']>
}

/** An individual person who uses Alice */
export type UserRoleArgs = {
  resourceId: Scalars['Int']
  roleName: RoleName
  roleType: RoleType
}

/** An individual person who uses Alice */
export type UserRolesArgs = {
  roleType: RoleType
}

/** An individual person who uses Alice */
export type UserTextMessagesArgs = {
  direction?: InputMaybe<TextMessageDirection>
  maxMessages?: InputMaybe<Scalars['Int']>
  sinceDays: Scalars['Int']
}

/** Autogenerated input type of UserHelpRequest */
export type UserHelpRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  fromUrl: Scalars['String']
  message: Scalars['String']
  responseRequested?: InputMaybe<Scalars['Boolean']>
}

/** Autogenerated return type of UserHelpRequest. */
export type UserHelpRequestPayload = {
  __typename?: 'UserHelpRequestPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success: Scalars['Boolean']
}

/** User lookup information for support agents */
export type UserLookup = {
  __typename?: 'UserLookup'
  /** The user's email address */
  email: Scalars['String']
  /** The user's employee ID (if they have an employee record) */
  employeeId?: Maybe<Scalars['Int']>
  /** The user's employer ID (if they have an employee record) */
  employerId?: Maybe<Scalars['Int']>
  /** Whether the user has admin privileges (business_admin or partner_executive role) */
  hasAdminRoles: Scalars['Boolean']
  /** Whether the user is currently blocked from AI support */
  isAiSupportBlocked: Scalars['Boolean']
  /** The user's organization ID (if they have an employee record) */
  organizationId?: Maybe<Scalars['Int']>
  /** The user's phone number */
  phoneNumber?: Maybe<Scalars['String']>
  /** The user's ID */
  userId: Scalars['Int']
}

/** Autogenerated input type of UserSignup */
export type UserSignupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The user's e-mail */
  email: Scalars['String']
  /** First name */
  firstName: Scalars['String']
  /** Last name */
  lastName: Scalars['String']
  /** Password */
  password: Scalars['String']
  /** Password confirmation */
  passwordConfirmation: Scalars['String']
  /** Preferred name */
  preferredName?: InputMaybe<Scalars['String']>
  /** The user's mobile phone number */
  tel: Scalars['String']
  utmParams?: InputMaybe<UtmParams>
}

/** Autogenerated return type of UserSignup. */
export type UserSignupPayload = {
  __typename?: 'UserSignupPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  currentUser?: Maybe<User>
  inputErrors: Array<InputError>
}

/** UTM Params, snake_case */
export type UtmParams = {
  utm_campaign?: InputMaybe<Scalars['String']>
  utm_content?: InputMaybe<Scalars['String']>
  utm_medium?: InputMaybe<Scalars['String']>
  utm_source?: InputMaybe<Scalars['String']>
  utm_term?: InputMaybe<Scalars['String']>
}

/** An identity verification */
export type Verification = {
  __typename?: 'Verification'
  id: Scalars['Int']
  /** Have the documents been verified? */
  isVerified: Scalars['Boolean']
}

/** Autogenerated input type of VerifyPhone */
export type VerifyPhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** 4 digit code sent to the user to validate its phone number */
  confirmationCode: Scalars['String']
}

/** Autogenerated return type of VerifyPhone. */
export type VerifyPhonePayload = {
  __typename?: 'VerifyPhonePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>
  inputErrors: Array<InputError>
  success?: Maybe<Scalars['Boolean']>
}

/** A Stripe Card's digital wallet eligibility */
export type WalletInfo = {
  __typename?: 'WalletInfo'
  eligible: Scalars['Boolean']
  ineligibleReason?: Maybe<Scalars['String']>
}

export type WorkLocation = {
  __typename?: 'WorkLocation'
  /** The address of the work location - only null if location setup is incomplete */
  address?: Maybe<AddressDisplay>
  /** @deprecated Use the employersInfo field instead */
  employerInfo?: Maybe<Employer>
  /** @deprecated Use the employerInfo field instead */
  employers?: Maybe<Array<Employer>>
  employersInfo?: Maybe<Array<Employer>>
  enrollmentMaterials?: Maybe<EnrollmentMaterials>
  id: Scalars['Int']
  latitude?: Maybe<Scalars['Float']>
  logo?: Maybe<Image>
  longitude?: Maybe<Scalars['Float']>
  name: Scalars['String']
  nickname?: Maybe<Scalars['String']>
  /** Preshift events scheduled for this work location */
  preshiftEvents: Array<PreshiftEvent>
}

export type WorkLocationAssignment = {
  __typename?: 'WorkLocationAssignment'
  employer: Employer
  id: Scalars['Int']
  workLocation: WorkLocation
}
